import React from 'react';

export const Facebook = ({ width = '32px', height = '32px' }) => {
    return (
        <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 512 512"
            xmlSpace="preserve"
            width={width}
            height={height}
        >
            <path
                style={{ fill: '#1976D2' }}
                d="M448,0H64C28.704,0,0,28.704,0,64v384c0,35.296,28.704,64,64,64h384c35.296,0,64-28.704,64-64V64
	C512,28.704,483.296,0,448,0z"
            />
            <path
                style={{ fill: '#FAFAFA' }}
                d="M432,256h-80v-64c0-17.664,14.336-16,32-16h32V96h-64l0,0c-53.024,0-96,42.976-96,96v64h-64v80h64
	v176h96V336h48L432,256z"
            />
        </svg>
    );
};
export const Linkedin = ({ width = '32px', height = '32px' }) => {
    return (
        <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 382 382"
            xmlSpace="preserve"
            width={width}
            height={height}
        >
            <path
                style={{ fill: '#0077B7' }}
                d="M347.445,0H34.555C15.471,0,0,15.471,0,34.555v312.889C0,366.529,15.471,382,34.555,382h312.889
       C366.529,382,382,366.529,382,347.444V34.555C382,15.471,366.529,0,347.445,0z M118.207,329.844c0,5.554-4.502,10.056-10.056,10.056
       H65.345c-5.554,0-10.056-4.502-10.056-10.056V150.403c0-5.554,4.502-10.056,10.056-10.056h42.806
       c5.554,0,10.056,4.502,10.056,10.056V329.844z M86.748,123.432c-22.459,0-40.666-18.207-40.666-40.666S64.289,42.1,86.748,42.1
       s40.666,18.207,40.666,40.666S109.208,123.432,86.748,123.432z M341.91,330.654c0,5.106-4.14,9.246-9.246,9.246H286.73
       c-5.106,0-9.246-4.14-9.246-9.246v-84.168c0-12.556,3.683-55.021-32.813-55.021c-28.309,0-34.051,29.066-35.204,42.11v97.079
       c0,5.106-4.139,9.246-9.246,9.246h-44.426c-5.106,0-9.246-4.14-9.246-9.246V149.593c0-5.106,4.14-9.246,9.246-9.246h44.426
       c5.106,0,9.246,4.14,9.246,9.246v15.655c10.497-15.753,26.097-27.912,59.312-27.912c73.552,0,73.131,68.716,73.131,106.472
       L341.91,330.654L341.91,330.654z"
            />
        </svg>
    );
};

export const Microsoft = ({ width = '32px', height = '32px' }) => {
    return (
        <svg
            width={width}
            height={height}
            x="0px"
            y="0px"
            viewBox="0 0 512 512"
        >
            <path
                style={{ fill: '#4CAF50' }}
                d="M272,240h240V16c0-8.832-7.168-16-16-16H272V240z"
            />
            <path
                style={{ fill: '#F44336' }}
                d="M240,240V0H16C7.168,0,0,7.168,0,16v224H240z"
            />
            <path
                style={{ fill: '#2196F3' }}
                d="M240,272H0v224c0,8.832,7.168,16,16,16h224V272z"
            />
            <path
                style={{ fill: '#FFC107' }}
                d="M272,272v240h224c8.832,0,16-7.168,16-16V272H272z"
            />
        </svg>
    );
};

export const Google = ({ width = '32px', height = '32px' }) => {
    return (
        <svg
            width={width}
            height={height}
            x="0px"
            y="0px"
            viewBox="0 0 512 512"
        >
            <path
                style={{ fill: '#FBBB00' }}
                d="M113.47,309.408L95.648,375.94l-65.139,1.378C11.042,341.211,0,299.9,0,256
        c0-42.451,10.324-82.483,28.624-117.732h0.014l57.992,10.632l25.404,57.644c-5.317,15.501-8.215,32.141-8.215,49.456
        C103.821,274.792,107.225,292.797,113.47,309.408z"
            />
            <path
                style={{ fill: '#518EF8' }}
                d="M507.527,208.176C510.467,223.662,512,239.655,512,256c0,18.328-1.927,36.206-5.598,53.451
        c-12.462,58.683-45.025,109.925-90.134,146.187l-0.014-0.014l-73.044-3.727l-10.338-64.535
        c29.932-17.554,53.324-45.025,65.646-77.911h-136.89V208.176h138.887L507.527,208.176L507.527,208.176z"
            />
            <path
                style={{ fill: '#28B446' }}
                d="M416.253,455.624l0.014,0.014C372.396,490.901,316.666,512,256,512
        c-97.491,0-182.252-54.491-225.491-134.681l82.961-67.91c21.619,57.698,77.278,98.771,142.53,98.771
        c28.047,0,54.323-7.582,76.87-20.818L416.253,455.624z"
            />
            <path
                style={{ fill: '#F14336' }}
                d="M419.404,58.936l-82.933,67.896c-23.335-14.586-50.919-23.012-80.471-23.012
        c-66.729,0-123.429,42.957-143.965,102.724l-83.397-68.276h-0.014C71.23,56.123,157.06,0,256,0
        C318.115,0,375.068,22.126,419.404,58.936z"
            />
        </svg>
    );
};

export const Star = () => {
    return (
        <svg
            height="511pt"
            viewBox="0 -10 511.98685 511"
            width="511pt"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="m114.59375 491.140625c-5.609375 0-11.179688-1.75-15.933594-5.1875-8.855468-6.417969-12.992187-17.449219-10.582031-28.09375l32.9375-145.089844-111.703125-97.960937c-8.210938-7.167969-11.347656-18.519532-7.976562-28.90625 3.371093-10.367188 12.542968-17.707032 23.402343-18.710938l147.796875-13.417968 58.433594-136.746094c4.308594-10.046875 14.121094-16.535156 25.023438-16.535156 10.902343 0 20.714843 6.488281 25.023437 16.511718l58.433594 136.769532 147.773437 13.417968c10.882813.980469 20.054688 8.34375 23.425782 18.710938 3.371093 10.367187.253906 21.738281-7.957032 28.90625l-111.703125 97.941406 32.9375 145.085938c2.414063 10.667968-1.726562 21.699218-10.578125 28.097656-8.832031 6.398437-20.609375 6.890625-29.910156 1.300781l-127.445312-76.160156-127.445313 76.203125c-4.308594 2.558594-9.109375 3.863281-13.953125 3.863281zm141.398438-112.875c4.84375 0 9.640624 1.300781 13.953124 3.859375l120.277344 71.9375-31.085937-136.941406c-2.21875-9.746094 1.089843-19.921875 8.621093-26.515625l105.472657-92.5-139.542969-12.671875c-10.046875-.917969-18.6875-7.234375-22.613281-16.492188l-55.082031-129.046875-55.148438 129.066407c-3.882812 9.195312-12.523438 15.511718-22.546875 16.429687l-139.5625 12.671875 105.46875 92.5c7.554687 6.613281 10.859375 16.769531 8.621094 26.539062l-31.0625 136.9375 120.277343-71.914062c4.308594-2.558594 9.109376-3.859375 13.953126-3.859375zm-84.585938-221.847656s0 .023437-.023438.042969zm169.128906-.0625.023438.042969c0-.023438 0-.023438-.023438-.042969zm0 0" />
        </svg>
    );
};

export const Warning = ({
    width = '32px',
    height = '32px',
    fill = '#484a53',
}) => {
    return (
        <svg
            x="0px"
            y="0px"
            viewBox="0 0 512 512"
            fill={fill}
            width={width}
            height={height}
        >
            <g>
                <g>
                    <g>
                        <path
                            d="M507.113,428.415L287.215,47.541c-6.515-11.285-18.184-18.022-31.215-18.022c-13.031,0-24.7,6.737-31.215,18.022
               L4.887,428.415c-6.516,11.285-6.516,24.76,0,36.044c6.515,11.285,18.184,18.022,31.215,18.022h439.796
               c13.031,0,24.7-6.737,31.215-18.022C513.629,453.175,513.629,439.7,507.113,428.415z M481.101,449.441
               c-0.647,1.122-2.186,3.004-5.202,3.004H36.102c-3.018,0-4.556-1.881-5.202-3.004c-0.647-1.121-1.509-3.394,0-6.007
               L250.797,62.559c1.509-2.613,3.907-3.004,5.202-3.004c1.296,0,3.694,0.39,5.202,3.004L481.1,443.434
               C482.61,446.047,481.748,448.32,481.101,449.441z"
                        />
                        <rect
                            x="240.987"
                            y="166.095"
                            width="30.037"
                            height="160.197"
                        />
                        <circle cx="256.005" cy="376.354" r="20.025" />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export const Confirm = ({
    width = '32px',
    height = '32px',
    fill = '#484a53',
}) => {
    return (
        <svg
            x="0px"
            y="0px"
            fill={fill}
            width={width}
            height={height}
            viewBox="0 0 305.002 305.002"
        >
            <g>
                <g>
                    <path
                        d="M152.502,0.001C68.412,0.001,0,68.412,0,152.501s68.412,152.5,152.502,152.5c84.089,0,152.5-68.411,152.5-152.5
           S236.591,0.001,152.502,0.001z M152.502,280.001C82.197,280.001,25,222.806,25,152.501c0-70.304,57.197-127.5,127.502-127.5
           c70.304,0,127.5,57.196,127.5,127.5C280.002,222.806,222.806,280.001,152.502,280.001z"
                    />
                    <path
                        d="M218.473,93.97l-90.546,90.547l-41.398-41.398c-4.882-4.881-12.796-4.881-17.678,0c-4.881,4.882-4.881,12.796,0,17.678
           l50.237,50.237c2.441,2.44,5.64,3.661,8.839,3.661c3.199,0,6.398-1.221,8.839-3.661l99.385-99.385
           c4.881-4.882,4.881-12.796,0-17.678C231.269,89.089,223.354,89.089,218.473,93.97z"
                    />
                </g>
            </g>
        </svg>
    );
};

export const Add = ({ width = '32px', height = '32px', fill = '#8ec358' }) => {
    return (
        <svg
            viewBox="0 0 426.66667 426.66667"
            width={width}
            height={height}
            fill={fill}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M405.33 192H234.67V21.33a21.34 21.34 0 00-42.67 0V192H21.33a21.34 21.34 0 000 42.67H192v170.66a21.34 21.34 0 0042.67 0V234.67h170.66a21.34 21.34 0 000-42.67zm0 0" />
        </svg>
    );
};

export const Equal = ({ width, height }) => {
    return (
        <svg
            version="1.1"
            width={width}
            height={height}
            x="0"
            y="0"
            viewBox="0 0 511.997 511.997"
        >
            <g>
                <g>
                    <path
                        d="M69.132,221.09h128.685V104.726H69.132c-31.864,0.377-57.497,26.315-57.497,58.182   S37.268,220.713,69.132,221.09L69.132,221.09z"
                        fill="#8fa7d6"
                    />
                    <path
                        d="M442.865,104.726H314.181V221.09h128.685c31.864-0.377,57.497-26.315,57.497-58.182   S474.73,105.103,442.865,104.726L442.865,104.726z"
                        fill="#8fa7d6"
                    />
                    <path
                        d="M407.956,104.726H104.041c-31.864,0.377-57.497,26.315-57.497,58.182s25.633,57.805,57.497,58.182   h303.915c31.864-0.377,57.497-26.315,57.497-58.182S439.821,105.103,407.956,104.726L407.956,104.726z"
                        fill="#8fa7d6"
                    />
                    <path
                        d="M69.132,407.271h128.685V290.908H69.132c-31.864,0.377-57.497,26.315-57.497,58.182   S37.268,406.894,69.132,407.271L69.132,407.271z"
                        fill="#8fa7d6"
                    />
                    <path
                        d="M442.865,290.908H314.181v116.364h128.685c31.864-0.377,57.497-26.315,57.497-58.182   S474.73,291.285,442.865,290.908z"
                        fill="#8fa7d6"
                    />
                    <path
                        d="M407.956,290.908H104.041c-31.864,0.377-57.497,26.315-57.497,58.182s25.633,57.805,57.497,58.182   h303.915c31.864-0.377,57.497-26.315,57.497-58.182S439.821,291.285,407.956,290.908z"
                        fill="#8fa7d6"
                    />
                    <g>
                        <path
                            d="M442.862,232.726H69.135C30.843,232.35,0,201.201,0,162.908S30.843,93.466,69.135,93.09h373.727    c38.292,0.376,69.135,31.525,69.135,69.818S481.154,232.35,442.862,232.726z M69.135,116.362    c-25.437,0.377-45.86,21.105-45.86,46.545c0,25.44,20.423,46.168,45.86,46.545h373.727c25.437-0.377,45.86-21.106,45.86-46.545    c0-25.44-20.423-46.168-45.86-46.545H69.135z"
                            fill="#4c72bd"
                        />
                        <path
                            d="M442.862,418.908H69.135C30.843,418.531,0,387.383,0,349.09s30.843-69.442,69.135-69.818h373.727    c38.292,0.376,69.135,31.525,69.135,69.818S481.154,418.531,442.862,418.908L442.862,418.908z M69.135,302.544    c-25.437,0.377-45.86,21.105-45.86,46.545s20.423,46.168,45.86,46.545h373.727c25.437-0.377,45.86-21.105,45.86-46.545    s-20.423-46.168-45.86-46.545H69.135z"
                            fill="#4c72bd"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export const Security = ({ width, height }) => {
    return (
        <svg
            version="1.1"
            width={width}
            height={height}
            x="0"
            y="0"
            viewBox="0 0 510.3 510.3"
        >
            <g>
                <g xmlns="http://www.w3.org/2000/svg">
                    <g>
                        <path
                            d="m129.52 269.26h72.88v173.54h-72.88z"
                            style={{ fill: '#d8d95c' }}
                        />
                        <path
                            d="m104.9 273.24 195-.44c8.25 0 15-6.75 15-15v-235.3c0-8.25-6.75-15-15-15h-195c-8.25 0-15 6.75-15 15v235.74c0 8.25 6.75 15 15 15z"
                            style={{ fill: '#8fa7d6' }}
                        />
                        <path
                            d="m168.458 205.799c-13.35 0-19.558-10.667-19.558-28.349 0-35.363 0-115.42 0-115.42 0-8.25-6.75-14.259-15-13.54l-40 3.483-4 90.777v115.05c0 8.25 6.75 35 15 35h74l19.558-87c0-.001-17.741-.001-30-.001z"
                            style={{ fill: '#4c72bd' }}
                        />
                        <path
                            d="m441.4 87.5h-195c-8.25 0-15 6.75-15 15v255.3z"
                            style={{ fill: '#a2abb8' }}
                        />
                        <path
                            d="m423.9 352.8h37.5c8.25 0 15-6.75 15-15v-255.3c0-8.25-6.75-15-15-15h-195c-8.25 0-15 6.75-15 15v255.3c0 8.25 164.25 15 172.5 15z"
                            style={{ fill: '#f6bcbc' }}
                        />
                        <path
                            d="m383.9 352.8h40v-120.3c0-8.25-6.75-15-15-15h-195z"
                            style={{ fill: '#ee8282' }}
                        />
                        <path
                            d="m193.9 452.8h19.664c8.25 0 190.336-6.75 190.336-15v-225.3c0-8.25-6.75-15-15-15h-195c-8.25 0-15 6.75-15 15v225.3c0 8.25 6.75 15 15 15z"
                            style={{ fill: '#8ec358' }}
                        />
                        <path
                            d="m332.955 303.358c-7.358-12.744-25.753-12.744-33.111 0l-86.28 149.442h175.336c8.25 0 15-6.75 15-15v-11.562z"
                            style={{ fill: '#8fa7d6' }}
                        />
                        <path
                            d="m48.9 62.969c0-.155.019-.312.023-.468l-.023.008c-8.25 3.003-15 12.209-15 20.459v344.832c0 8.25 6.75 17.457 15 20.459l85 30.938c8.25 3.003 15-1.29 15-9.54 0 0 0-3.805 0-10.46z"
                            style={{ fill: '#ffd064' }}
                        />
                        <path
                            d="m134.458 196.799c-10.407-8.425-15.558-11.667-15.558-29.349 0-35.363 0-115.42 0-115.42 0-8.25-6.75-12.543-15-9.54l-54.977 20.01c-.005.156-.023.313-.023.468v344.832c0 8.25 6.75 17.457 15 20.459l85 30.938c0-42.443 0-201.078 0-231.648 0-17.682-4.035-22.324-14.442-30.75z"
                            style={{ fill: '#e2e283' }}
                        />
                        <path
                            d="m473.095 474.125-110.14-190.767c-7.358-12.744-25.753-12.744-33.111 0l-110.139 190.767c-7.358 12.744 1.839 28.675 16.555 28.675h220.279c14.716 0 23.914-15.931 16.556-28.675z"
                            style={{ fill: '#ee8282' }}
                        />
                    </g>
                    <g>
                        <path
                            d="m138.428 190.365c11.706 9.477 17.972 16.78 17.972 37.184v57.751h15v-72.8c0-12.406 10.094-22.5 22.5-22.5h50v-107.5c0-12.406 10.094-22.5 22.5-22.5h137.5c4.143 0 7.5 3.357 7.5 7.5s-3.357 7.5-7.5 7.5h-137.5c-4.136 0-7.5 3.364-7.5 7.5v107.5h130c12.406 0 22.5 10.094 22.5 22.5v132.8h50c4.136 0 7.5-3.364 7.5-7.5v-255.3c0-4.136-3.364-7.5-7.5-7.5h-27.5c-4.143 0-7.5-3.357-7.5-7.5s3.357-7.5 7.5-7.5h27.5c12.406 0 22.5 10.094 22.5 22.5v255.3c0 12.406-10.094 22.5-22.5 22.5h-45.362l36.391 63.03c2.071 3.587.842 8.174-2.745 10.245-3.586 2.07-8.175.843-10.245-2.745l-82.979-143.722c-2.1-3.638-5.861-5.809-10.061-5.809s-7.961 2.171-10.061 5.809l-110.137 190.767c-2.1 3.637-2.1 7.979 0 11.616 2.1 3.638 5.86 5.809 10.06 5.809h220.279c4.199 0 7.96-2.171 10.06-5.809 2.1-3.637 2.1-7.979 0-11.616l-12.312-21.325c-2.071-3.587-.842-8.174 2.745-10.245 3.586-2.069 8.175-.843 10.245 2.745l12.312 21.325c4.812 8.333 4.812 18.283.001 26.616-4.812 8.333-13.429 13.309-23.051 13.309h-220.28c-9.622 0-18.239-4.976-23.051-13.309-4.811-8.333-4.811-18.283.001-26.616l5.816-10.075h-25.126c-7.785 0-14.659-3.974-18.7-10h-18.8v19.356c0 6.24-2.651 11.676-7.275 14.914-4.866 3.407-11.35 4.018-17.789 1.675l-85.001-30.938c-11.178-4.069-19.935-16.151-19.935-27.507v-344.831c0-11.356 8.757-23.438 19.935-27.508l36.065-13.127v-19.834c0-12.406 10.094-22.5 22.5-22.5h195c12.406 0 22.5 10.094 22.5 22.5v13.3c0 4.143-3.357 7.5-7.5 7.5s-7.5-3.357-7.5-7.5v-13.3c0-4.136-3.364-7.5-7.5-7.5h-195c-4.136 0-7.5 3.364-7.5 7.5v14.375l3.935-1.433c6.44-2.343 12.924-1.732 17.79 1.675 4.624 3.238 7.275 8.674 7.275 14.914v85.42c0 4.143-3.357 7.5-7.5 7.5s-7.5-3.357-7.5-7.5v-85.42c0-.604-.086-2.071-.879-2.627-.61-.428-1.995-.615-4.057.134l-54.999 20.019c-5.267 1.917-10.065 8.309-10.065 13.412v344.831c0 5.103 4.798 11.495 10.065 13.412l85 30.938c2.061.75 3.444.562 4.056.134.793-.556.879-2.022.879-2.627v-242.108c0-14.821-3.344-18.186-12.395-25.513-10.774-8.675-17.605-15.123-17.605-34.585 0-4.143 3.357-7.5 7.5-7.5s7.5 3.357 7.5 7.5c0 13.23 3.139 15.758 12.028 22.914zm55.472 14.635c-4.136 0-7.5 3.364-7.5 7.5v225.3c0 4.136 3.364 7.5 7.5 7.5h33.787l95.662-165.691c4.812-8.334 13.429-13.309 23.051-13.309s18.239 4.975 23.051 13.309l26.949 46.678v-113.787c0-4.136-3.364-7.5-7.5-7.5zm-37.5 230.3h15v-135h-15zm190 29c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm0-29.72c-4.143 0-7.5-3.357-7.5-7.5v-76.36c0-4.143 3.357-7.5 7.5-7.5s7.5 3.357 7.5 7.5v76.36c0 4.143-3.358 7.5-7.5 7.5z"
                            style={{ fill: '#000000' }}
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export const Stock = ({ width, height }) => {
    return (
        <svg
            version="1.1"
            width={width}
            height={height}
            x="0"
            y="0"
            viewBox="0 0 511.999 511.999"
        >
            <g>
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="M51.599,247.151l76.355-40.526c1.904-1.011,4.242-0.687,5.8,0.803l95.278,91.128  c1.827,1.747,4.671,1.856,6.626,0.253l57.323-46.997c2.174-1.782,5.389-1.423,7.115,0.795l23.232,29.838  c1.435,1.843,3.956,2.447,6.071,1.454l58.252-27.357c0.848-0.398,1.79-0.55,2.72-0.439l92.173,11.04  c2.513,0.301,4.405,2.433,4.405,4.965v231.786H48.943V251.568C48.942,249.718,49.963,248.019,51.599,247.151z"
                    fill="#f6bcbc"
                />
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="M387.648,256.543L329.4,283.896c-2.114,0.993-4.635,0.389-6.07-1.454l-23.235-29.834  c-1.727-2.217-4.941-2.576-7.115-0.794l-57.324,46.996c-1.955,1.603-4.799,1.494-6.626-0.253l-95.278-91.128  c-1.558-1.49-3.896-1.814-5.8-0.803l-76.278,40.485c-1.675,0.889-2.703,2.649-2.654,4.544l0.921,35.99l74.025-37.571  c1.802-0.914,3.977-0.655,5.512,0.658l101.783,87.033c1.794,1.534,4.417,1.604,6.291,0.169l44.524-34.118  c1.711-1.311,4.07-1.378,5.853-0.166l24.727,16.818c1.456,0.99,3.325,1.142,4.921,0.399l61.639-28.681  c0.984-0.458,2.09-0.583,3.151-0.357l66.949,14.262c2.308,0.492,3.958,2.53,3.958,4.89v192.914h28.67c2.761,0,5-2.239,5-5V272.11  c0-2.531-1.892-4.663-4.405-4.965l-92.173-11.042C389.439,255.992,388.496,256.143,387.648,256.543z"
                    fill="#ee8282"
                />
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="M48.942,395.269l60.245-32.335l179.758,22.825l83.801-22.825l46.2,51.65l68.001-51.65v135.959  c0,2.761-2.239,5-5,5H48.942C48.942,503.893,48.942,395.269,48.942,395.269z"
                    fill="#8fa7d6"
                />
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="M486.947,362.934v135.961c0,2.761-2.239,5-5,5h-28.67v-75.919c0-4.134-4.732-6.482-8.024-3.982  l-43.181,32.799c-2.075,1.576-5.013,1.294-6.751-0.648l-41.064-45.908c-1.262-1.411-3.214-1.988-5.041-1.491l-79.861,21.757  c-0.633,0.172-1.293,0.219-1.944,0.136L90.219,408.136c-1.032-0.131-2.079,0.063-2.995,0.555l-38.281,20.553v-33.97l58.832-31.584  c0.916-0.492,1.963-0.686,2.995-0.555l177.19,22.503c0.651,0.083,1.311,0.036,1.944-0.136l79.861-21.757  c1.827-0.498,3.779,0.079,5.041,1.491l41.064,45.908c1.737,1.942,4.676,2.225,6.751,0.648L486.947,362.934z"
                    fill="#4c72bd"
                />
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="M504.47,497l-10.023-0.065v-23.458c0-4.142-3.357-7.5-7.5-7.5c-4.143,0-7.5,3.358-7.5,7.5v22.917H56.443v-96.096  l54.18-29.08l176.394,22.398c1.637,0.208,3.269,0.093,4.858-0.34l78.372-21.346l40.034,44.755  c4.312,4.821,11.725,5.534,16.877,1.621l52.29-39.716v1.344v40.042c0,4.142,3.357,7.5,7.5,7.5c4.143,0,7.5-3.358,7.5-7.5v-40.042  v-6.382V272.108c0-6.323-4.734-11.659-11.014-12.412l-92.173-11.04c-2.327-0.278-4.68,0.102-6.8,1.097l-56.443,26.508  l-22.005-28.263c-2.089-2.681-5.1-4.365-8.477-4.742c-3.382-0.378-6.685,0.602-9.311,2.756l-55.611,45.593l-23.534-22.508  c-2.994-2.863-7.741-2.757-10.604,0.236c-2.863,2.994-2.758,7.741,0.236,10.604l25.135,24.041  c4.564,4.363,11.685,4.633,16.564,0.632l55.341-45.372l21.657,27.816c3.613,4.64,9.854,6.135,15.176,3.634l57.604-27.052  l89.258,10.69v85.608c-3.529,2.5-3.529,2.5-5.061,3.664l-54.465,41.368l-39.525-44.187c-3.176-3.552-8.006-4.979-12.602-3.728  l-79.383,21.622l-176.694-22.437c-2.595-0.327-5.183,0.151-7.485,1.387l-47.789,25.65V253.071l73.433-38.975l29.447,28.166  c2.993,2.863,7.741,2.757,10.604-0.236s2.758-7.741-0.236-10.604l-30.753-29.416c-3.903-3.731-9.731-4.536-14.5-2.005  l-76.355,40.525c-4.096,2.174-6.64,6.404-6.64,11.041v147.233v98.133h-17.08v-57.206h3c4.143,0,7.5-3.358,7.5-7.5  c0-4.142-3.357-7.5-7.5-7.5h-3v-76.834h3c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5h-3V256.06h3c4.143,0,7.5-3.358,7.5-7.5  c0-4.142-3.357-7.5-7.5-7.5h-3v-76.834h3c4.143,0,7.5-3.358,7.5-7.5c0-4.142-3.357-7.5-7.5-7.5h-3V72.393h3  c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5h-3L24.514,7.5c0-4.142-3.357-7.5-7.5-7.5s-7.5,3.358-7.5,7.5L9.362,57.393H7.529  c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5,7.5,7.5h1.833v76.834H7.529c-4.143,0-7.5,3.358-7.5,7.5c0,4.142,3.357,7.5,7.5,7.5h1.833  v76.834H7.529c-4.143,0-7.5,3.358-7.5,7.5c0,4.142,3.357,7.5,7.5,7.5h1.833v76.834H7.529c-4.143,0-7.5,3.358-7.5,7.5  s3.357,7.5,7.5,7.5h1.833v76.834H7.529c-4.143,0-7.5,3.358-7.5,7.5c0,4.142,3.357,7.5,7.5,7.5h1.833v64.706  c0,4.142,3.357,7.5,7.5,7.5h32.08h438.004l17.523,0.065c4.143,0,7.5-3.358,7.5-7.5C511.97,500.357,508.612,497,504.47,497z"
                    fill="#484a53"
                />
            </g>
        </svg>
    );
};

export const Like = ({ width, height }) => {
    return (
        <svg
            version="1.1"
            width={width}
            height={height}
            x="0"
            y="0"
            viewBox="0 0 512 512"
            xmlSpace="preserve"
        >
            <g>
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="M170.409,299.115v-35.797c0-12.434-10.08-22.513-22.513-22.513H10v259.351h137.896  c12.434,0,22.513-10.08,22.513-22.513v-111.44V299.115z"
                    style={{ fill: '#ee8282' }}
                />
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="M469.581,307.487l-26.021-0.003c17.904,0,32.419-14.514,32.419-32.419l0,0  c0-17.904-14.514-32.419-32.419-32.419h-125.2l19-56.41c10.346-30.717-6.74-63.908-37.75-73.336l-17.545-5.334l-27.569,76.195  c-8.648,23.902-25.749,43.811-48.072,55.966l-36.685,19.976l0.669,223.224l23.329,9.149c16.72,6.557,34.52,9.923,52.48,9.923  h105.381h34.218h35.136c17.904,0,32.419-14.514,32.419-32.419l0,0c0-17.904-14.514-32.419-32.419-32.419h25.201  c17.904,0,32.419-14.514,32.419-32.419l0,0c0-17.904-14.514-32.419-32.419-32.419h23.428c17.904,0,32.419-14.514,32.419-32.419l0,0  C502,322.001,487.486,307.487,469.581,307.487z"
                    style={{ fill: '#ffcdac' }}
                />
                <circle
                    xmlns="http://www.w3.org/2000/svg"
                    cx="109.17"
                    cy="443.54"
                    r="18.01"
                    style={{ fill: '#ffffff' }}
                />
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="M170.41,327.89c-2.631,0-5.21,1.061-7.07,2.92c-1.86,1.87-2.93,4.45-2.93,7.07c0,2.64,1.069,5.21,2.93,7.07  c1.86,1.869,4.439,2.93,7.07,2.93c2.63,0,5.21-1.061,7.069-2.93c1.86-1.86,2.931-4.431,2.931-7.07c0-2.62-1.07-5.2-2.931-7.07  C175.62,328.95,173.04,327.89,170.41,327.89z"
                    style={{ fill: '#484a53' }}
                />
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="M512,339.906c0-20.195-14.191-37.128-33.122-41.38c4.482-6.724,7.101-14.792,7.101-23.461  c0-23.39-19.029-42.419-42.419-42.419H332.28l14.557-43.217c5.875-17.441,4.471-36.058-3.952-52.421  c-8.423-16.362-22.759-28.322-40.365-33.675L284.975,98c-5.099-1.551-10.503,1.163-12.313,6.165l-27.569,76.194  c-7.825,21.625-23.256,39.59-43.451,50.586l-27.541,14.998c-5.924-8.056-15.462-13.296-26.205-13.296H10c-5.522,0-10,4.478-10,10  v259.352c0,5.522,4.478,10,10,10h137.896c11.963,0,22.43-6.499,28.076-16.147l14.115,5.536C208.045,508.43,226.93,512,246.217,512  h174.735c23.39,0,42.419-19.029,42.419-42.419c0-8.739-2.658-16.867-7.205-23.624c18.572-4.513,32.406-21.274,32.406-41.214  c0-8.911-2.768-17.185-7.481-24.019C498.903,375.694,512,359.306,512,339.906z M469.581,362.324h-23.428h-45.926h-33.501  c-5.522,0-10,4.478-10,10s4.478,10,10,10h33.501h45.926c12.362,0,22.419,10.057,22.419,22.419s-10.057,22.419-22.419,22.419h-25.201  h-50.819h-3.406c-5.522,0-10,4.478-10,10s4.478,10,10,10h3.406h50.819c12.362,0,22.419,10.057,22.419,22.419  S433.314,492,420.952,492H246.217c-16.778,0-33.206-3.106-48.828-9.232l-16.979-6.659V378c0-5.522-4.478-10-10-10s-10,4.478-10,10  v101.484c0,6.9-5.613,12.514-12.514,12.514H20V252.646h127.896c6.9,0,12.514,5.613,12.514,12.514v33.955c0,5.522,4.478,10,10,10  s10-4.478,10-10V265.28l30.797-16.771c24.491-13.335,43.204-35.121,52.693-61.346l24.34-67.268l8.462,2.572  c12.389,3.767,22.475,12.181,28.401,23.694c5.927,11.513,6.914,24.611,2.781,36.882l-19,56.409  c-1.028,3.052-0.523,6.411,1.354,9.026c1.879,2.615,4.902,4.166,8.122,4.166h125.2c12.362,0,22.419,10.057,22.419,22.419  s-10.057,22.419-22.419,22.419h-76.834c-5.522,0-10,4.478-10,10s4.478,10,10,10h33.443c0.02,0,0.039,0.003,0.058,0.003h69.354  c12.362,0,22.419,10.057,22.419,22.419C492,352.268,481.943,362.324,469.581,362.324z"
                    style={{ fill: '#484a53' }}
                />
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="M109.173,415.53c-15.445,0-28.011,12.565-28.011,28.01s12.565,28.011,28.011,28.011s28.011-12.565,28.011-28.011  C137.184,428.096,124.618,415.53,109.173,415.53z M109.173,451.551c-4.417,0-8.011-3.594-8.011-8.011s3.594-8.01,8.011-8.01  s8.011,3.593,8.011,8.01S113.59,451.551,109.173,451.551z"
                    style={{ fill: '#484a53' }}
                />
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="M298.819,20c2.631,0,5.21-1.07,7.07-2.931c1.86-1.859,2.93-4.439,2.93-7.069s-1.069-5.21-2.93-7.07S301.45,0,298.819,0  c-2.63,0-5.21,1.069-7.069,2.93c-1.86,1.86-2.931,4.44-2.931,7.07s1.07,5.21,2.931,7.069C293.609,18.93,296.189,20,298.819,20z"
                    style={{ fill: '#484a53' }}
                />
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="M298.82,37.333c-5.522,0-10,4.478-10,10v24.334c0,5.522,4.478,10,10,10s10-4.478,10-10V47.333  C308.82,41.811,304.343,37.333,298.82,37.333z"
                    style={{ fill: '#484a53' }}
                />
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="M358.393,141.266c0,5.522,4.478,10,10,10h61.666c5.522,0,10-4.478,10-10s-4.478-10-10-10h-61.666  C362.87,131.266,358.393,135.743,358.393,141.266z"
                    style={{ fill: '#484a53' }}
                />
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="M167.554,151.239h61.667c5.522,0,10-4.478,10-10s-4.478-10-10-10h-61.667c-5.522,0-10,4.478-10,10  S162.031,151.239,167.554,151.239z"
                    style={{ fill: '#484a53' }}
                />
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="M235.207,91.776c1.953,1.952,4.512,2.929,7.071,2.929s5.118-0.977,7.071-2.929c3.905-3.905,3.905-10.237,0-14.143  l-29.115-29.115c-3.906-3.904-10.236-3.904-14.143,0c-3.905,3.905-3.905,10.237,0,14.143L235.207,91.776z"
                    style={{ fill: '#484a53' }}
                />
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="M355.354,94.724c2.56,0,5.118-0.977,7.071-2.929L391.54,62.68c3.905-3.905,3.905-10.237,0-14.143  c-3.906-3.904-10.236-3.904-14.143,0l-29.115,29.115c-3.905,3.905-3.905,10.237,0,14.143  C350.235,93.747,352.794,94.724,355.354,94.724z"
                    style={{ fill: '#484a53' }}
                />
            </g>
        </svg>
    );
};

export const BigArrow = ({ width, height, fill, fillMain, transform }) => {
    return (
        <svg
            version="1.1"
            width={width}
            height={height}
            x="0"
            y="0"
            viewBox="0 0 512 512"
            style={transform ? transform : {}}
        >
            <g>
                <path
                    d="M16.812,65.299c0-34.546,31.418-60.518,65.37-54.137c68.568,12.886,131.647,46.02,182.055,96.429  c55.695,55.694,90.299,126.858,99.809,203.801l36.347-36.347c21.213-21.213,55.775-22.512,77.561-1.889  c22.604,21.396,22.973,57.076,1.11,78.941L345.454,485.707c-21.5,21.5-56.36,21.5-77.861,0L133.984,352.098  c-10.75-10.751-16.125-24.84-16.125-38.93c0-14.487,5.682-28.974,17.046-39.831c21.759-20.788,56.443-19.596,77.723,1.682  l40.758,40.758c-16.381-99.088-93.71-177.881-192.061-196.418C35.433,114.477,16.812,91.645,16.812,65.299L16.812,65.299z"
                    fill={fill ? fill : '#bfdda1'}
                />
                <g>
                    <path
                        d="M306.523,512c-16.711,0-33.421-6.361-46.143-19.082L126.771,359.309   c-12.325-12.326-19.113-28.712-19.113-46.143c0-17.998,7.174-34.761,20.201-47.205c25.417-24.286,66.679-23.455,91.98,1.844   l14.887,14.887c-25.974-78.049-92.826-137.767-175.291-153.31c-30.608-5.77-52.824-32.72-52.824-64.082   c0-19.482,8.6-37.789,23.592-50.227C45.232,2.607,64.866-2.473,84.066,1.137c71.008,13.345,135.805,47.661,187.383,99.24   c52.45,52.449,86.645,117.627,99.645,189.54l22.083-22.084c12.161-12.161,28.317-19.128,45.489-19.616   c17.359-0.52,33.832,5.731,46.298,17.532c12.922,12.232,20.172,28.752,20.418,46.516c0.244,17.771-6.541,34.479-19.107,47.045   L352.667,492.919C339.943,505.64,323.232,512,306.523,512z M172.552,268.625c-11.119,0-22.149,4.009-30.602,12.085   c-8.959,8.559-13.892,20.084-13.892,32.455c0,11.981,4.665,23.246,13.139,31.718l133.609,133.609   c17.489,17.489,45.946,17.489,63.435,0l133.609-133.609c8.637-8.637,13.302-20.122,13.133-32.339   c-0.167-12.21-5.155-23.567-14.042-31.981c-17.462-16.528-45.876-15.769-63.338,1.694l-36.345,36.345   c-2.757,2.757-6.842,3.702-10.529,2.433c-3.686-1.267-6.328-4.526-6.806-8.394c-9.313-75.35-42.819-143.761-96.899-197.839   C208.362,66.14,147.251,33.768,80.297,21.187c-13.217-2.487-26.73,1.009-37.07,9.586c-10.306,8.551-16.217,21.134-16.217,34.527   c0,21.562,15.224,40.081,36.2,44.034c102.719,19.361,183.187,101.655,200.235,204.779c0.723,4.372-1.461,8.711-5.402,10.735   c-3.942,2.028-8.739,1.274-11.875-1.859l-40.758-40.759C196.367,273.185,184.409,268.625,172.552,268.625z"
                        fill={fillMain ? fillMain : '#8ec358'}
                    />
                    <path
                        d="M295.477,475.187c-2.611,0-5.22-0.997-7.212-2.988l-74.153-74.154   c-3.983-3.983-3.983-10.442,0-14.426c3.985-3.982,10.442-3.98,14.426,0l74.153,74.154c3.983,3.983,3.983,10.442,0,14.426   C300.699,474.191,298.088,475.187,295.477,475.187z"
                        fill={fillMain ? fillMain : '#8ec358'}
                    />
                    <path
                        d="M196.385,375.917c-2.611,0-5.22-0.997-7.212-2.988l-5.665-5.665c-3.983-3.983-3.983-10.442,0-14.426   c3.984-3.982,10.441-3.982,14.426,0l5.665,5.665c3.983,3.983,3.983,10.442,0,14.426   C201.605,374.92,198.996,375.917,196.385,375.917z"
                        fill={fillMain ? fillMain : '#8ec358'}
                    />
                </g>
            </g>
        </svg>
    );
};

export const Trash = ({
    width = '32',
    height = '32',
    fill = '#fff',
    transform,
}) => {
    return (
        <svg
            height={height}
            viewBox="-47 0 512 512"
            width={width}
            xmlns="http://www.w3.org/2000/svg"
            fill={fill}
            transform={transform ? transform : null}
        >
            <path d="m416.875 114.441406-11.304688-33.886718c-4.304687-12.90625-16.339843-21.578126-29.941406-21.578126h-95.011718v-30.933593c0-15.460938-12.570313-28.042969-28.027344-28.042969h-87.007813c-15.453125 0-28.027343 12.582031-28.027343 28.042969v30.933593h-95.007813c-13.605469 0-25.640625 8.671876-29.945313 21.578126l-11.304687 33.886718c-2.574219 7.714844-1.2695312 16.257813 3.484375 22.855469 4.753906 6.597656 12.445312 10.539063 20.578125 10.539063h11.816406l26.007813 321.605468c1.933594 23.863282 22.183594 42.558594 46.109375 42.558594h204.863281c23.921875 0 44.175781-18.695312 46.105469-42.5625l26.007812-321.601562h6.542969c8.132812 0 15.824219-3.941407 20.578125-10.535157 4.753906-6.597656 6.058594-15.144531 3.484375-22.859375zm-249.320312-84.441406h83.0625v28.976562h-83.0625zm162.804687 437.019531c-.679687 8.402344-7.796875 14.980469-16.203125 14.980469h-204.863281c-8.40625 0-15.523438-6.578125-16.203125-14.980469l-25.816406-319.183593h288.898437zm-298.566406-349.183593 9.269531-27.789063c.210938-.640625.808594-1.070313 1.484375-1.070313h333.082031c.675782 0 1.269532.429688 1.484375 1.070313l9.269531 27.789063zm0 0" />
            <path d="m282.515625 465.957031c.265625.015625.527344.019531.792969.019531 7.925781 0 14.550781-6.210937 14.964844-14.21875l14.085937-270.398437c.429687-8.273437-5.929687-15.332031-14.199219-15.761719-8.292968-.441406-15.328125 5.925782-15.761718 14.199219l-14.082032 270.398437c-.429687 8.273438 5.925782 15.332032 14.199219 15.761719zm0 0" />
            <path d="m120.566406 451.792969c.4375 7.996093 7.054688 14.183593 14.964844 14.183593.273438 0 .554688-.007812.832031-.023437 8.269531-.449219 14.609375-7.519531 14.160157-15.792969l-14.753907-270.398437c-.449219-8.273438-7.519531-14.613281-15.792969-14.160157-8.269531.449219-14.609374 7.519532-14.160156 15.792969zm0 0" />
            <path d="m209.253906 465.976562c8.285156 0 15-6.714843 15-15v-270.398437c0-8.285156-6.714844-15-15-15s-15 6.714844-15 15v270.398437c0 8.285157 6.714844 15 15 15zm0 0" />
        </svg>
    );
};

export const Arrow = ({
    width = '32px',
    height = '32px',
    fill = '#fff',
    transform = 'rotate(0)',
}) => {
    return (
        <svg
            version="1.1"
            id="Capa_1"
            x="0px"
            y="0px"
            width={width}
            height={height}
            viewBox="0 0 451.847 451.847"
            fill={fill}
            transform={transform}
        >
            <g>
                <path
                    d="M225.923,354.706c-8.098,0-16.195-3.092-22.369-9.263L9.27,151.157c-12.359-12.359-12.359-32.397,0-44.751
   c12.354-12.354,32.388-12.354,44.748,0l171.905,171.915l171.906-171.909c12.359-12.354,32.391-12.354,44.744,0
   c12.365,12.354,12.365,32.392,0,44.751L248.292,345.449C242.115,351.621,234.018,354.706,225.923,354.706z"
                />
            </g>
        </svg>
    );
};

export const Copy = ({ width = '32px', height = '32px' }) => {
    return (
        <svg
            x="0px"
            y="0px"
            width={width}
            height={height}
            viewBox="0 0 512 512"
            fill="#4c72bd"
        >
            <g>
                <g>
                    <path
                        d="M464.867,96.4h-81.4V15c0-8.284-6.716-15-15-15H47.133c-8.284,0-15,6.716-15,15v385.601c0,8.284,6.716,15,15,15h81.4V497
           c0,8.284,6.716,15,15,15h321.334c8.284,0,15-6.716,15-15V111.4C479.867,103.116,473.151,96.4,464.867,96.4z M62.133,385.601V30
           h291.334v81.149c-0.002,0.084-0.013,0.166-0.013,0.251c0,0.085,0.011,0.167,0.013,0.252v273.949H62.133z M449.867,482H158.533
           v-66.399h209.934c8.284,0,15-6.716,15-15V126.4h66.4V482z"
                    />
                </g>
            </g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
        </svg>
    );
};

export const UploadIcon = ({ fill = '#484A53' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height="60"
            version="1.1"
            viewBox="-53 1 511 511.99906"
            width="60"
            fill={fill}
        >
            <g id="surface1">
                <path d="M 276.410156 3.957031 C 274.0625 1.484375 270.84375 0 267.507812 0 L 67.777344 0 C 30.921875 0 0.5 30.300781 0.5 67.152344 L 0.5 444.84375 C 0.5 481.699219 30.921875 512 67.777344 512 L 338.863281 512 C 375.71875 512 406.140625 481.699219 406.140625 444.84375 L 406.140625 144.941406 C 406.140625 141.726562 404.65625 138.636719 402.554688 136.285156 Z M 279.996094 43.65625 L 364.464844 132.328125 L 309.554688 132.328125 C 293.230469 132.328125 279.996094 119.21875 279.996094 102.894531 Z M 338.863281 487.265625 L 67.777344 487.265625 C 44.652344 487.265625 25.234375 468.097656 25.234375 444.84375 L 25.234375 67.152344 C 25.234375 44.027344 44.527344 24.734375 67.777344 24.734375 L 255.261719 24.734375 L 255.261719 102.894531 C 255.261719 132.945312 279.503906 157.0625 309.554688 157.0625 L 381.40625 157.0625 L 381.40625 444.84375 C 381.40625 468.097656 362.113281 487.265625 338.863281 487.265625 Z M 338.863281 487.265625 " />
                <path d="M 305.101562 401.933594 L 101.539062 401.933594 C 94.738281 401.933594 89.171875 407.496094 89.171875 414.300781 C 89.171875 421.101562 94.738281 426.667969 101.539062 426.667969 L 305.226562 426.667969 C 312.027344 426.667969 317.59375 421.101562 317.59375 414.300781 C 317.59375 407.496094 312.027344 401.933594 305.101562 401.933594 Z M 305.101562 401.933594 " />
                <path d="M 140 268.863281 L 190.953125 214.074219 L 190.953125 349.125 C 190.953125 355.925781 196.519531 361.492188 203.320312 361.492188 C 210.125 361.492188 215.6875 355.925781 215.6875 349.125 L 215.6875 214.074219 L 266.640625 268.863281 C 269.113281 271.457031 272.332031 272.820312 275.667969 272.820312 C 278.636719 272.820312 281.730469 271.707031 284.078125 269.480469 C 289.027344 264.78125 289.398438 256.988281 284.699219 252.042969 L 212.226562 174.253906 C 209.875 171.78125 206.660156 170.296875 203.199219 170.296875 C 199.734375 170.296875 196.519531 171.78125 194.171875 174.253906 L 121.699219 252.042969 C 117 256.988281 117.371094 264.902344 122.316406 269.480469 C 127.511719 274.179688 135.300781 273.808594 140 268.863281 Z M 140 268.863281 " />
            </g>
        </svg>
    );
};

export const TimeSelector = ({ fill, width, height }) => {
    return (
        <svg
            viewBox="0 0 64 64"
            fill={fill}
            widths={width}
            height={height}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="m31 56h2v2h-2z" />
            <path
                d="m48.678 48.678h2v2h-2z"
                transform="matrix(.707 -.707 .707 .707 -20.577 49.678)"
            />
            <path d="m56 31h2v2h-2z" />
            <path d="m61 25h-7.09a22.547 22.547 0 0 0 -1.465-3.542l5.011-5.012a1 1 0 0 0 0-1.414l-4.243-4.242a30 30 0 1 0 -42.426 42.423l4.242 4.243a1 1 0 0 0 1.414 0l5.012-5.011a22.559 22.559 0 0 0 3.545 1.464v7.091a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-7.09a22.559 22.559 0 0 0 3.542-1.464l5.012 5.011a1 1 0 0 0 1.414 0l8.485-8.485a1 1 0 0 0 0-1.414l-5.011-5.012a22.559 22.559 0 0 0 1.467-3.546h7.091a1 1 0 0 0 1-1v-12a1 1 0 0 0 -1-1zm-48.8-12.8a27.989 27.989 0 0 1 38.874-.69l-1.412 1.412a26 26 0 0 0 -36.74 36.74l-1.412 1.412a27.989 27.989 0 0 1 .69-38.874zm28.285 11.315a12 12 0 0 1 -16.97 16.97 1 1 0 0 0 -1.414 0l-7.764 7.764a24 24 0 0 1 33.912-33.912l-7.764 7.763a1 1 0 0 0 0 1.415zm19.515 13.485h-6.836a1 1 0 0 0 -.964.732 20.49 20.49 0 0 1 -1.861 4.5 1 1 0 0 0 .166 1.2l4.829 4.83-7.07 7.07-4.83-4.829a1 1 0 0 0 -1.2-.166 20.49 20.49 0 0 1 -4.5 1.861 1 1 0 0 0 -.732.964v6.838h-10.002v-6.836a1 1 0 0 0 -.732-.964 20.49 20.49 0 0 1 -4.5-1.861 1 1 0 0 0 -1.2.166l-4.83 4.829-2.828-2.828 9.925-9.924a14 14 0 0 0 19.747-19.749l9.924-9.925 2.828 2.828-4.829 4.83a1 1 0 0 0 -.166 1.2 20.473 20.473 0 0 1 1.861 4.5 1 1 0 0 0 .964.732h6.836z" />
            <path d="m33 28.142v-11.142a1 1 0 0 0 -2 0v11.142a4 4 0 0 0 -2.858 2.858h-7.142a1 1 0 0 0 0 2h7.142a3.992 3.992 0 1 0 4.858-4.858zm-1 5.858a2 2 0 1 1 2-2 2 2 0 0 1 -2 2z" />
            <path d="m32 13a1 1 0 0 1 -1-1v-2a1 1 0 0 1 2 0v2a1 1 0 0 1 -1 1z" />
            <path d="m42 15.68a1 1 0 0 1 -.865-1.5l1-1.733a1 1 0 0 1 1.732 1l-1 1.733a1 1 0 0 1 -.867.5z" />
            <path d="m22 15.68a1 1 0 0 1 -.867-.5l-1-1.733a1 1 0 0 1 1.732-1l1 1.733a1 1 0 0 1 -.865 1.5z" />
            <path d="m14.679 23a.992.992 0 0 1 -.5-.134l-1.733-1a1 1 0 0 1 1-1.732l1.733 1a1 1 0 0 1 -.5 1.866z" />
            <path d="m12 33h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2z" />
            <path d="m12.948 44a1 1 0 0 1 -.5-1.866l1.733-1a1 1 0 1 1 1 1.732l-1.733 1a.992.992 0 0 1 -.5.134z" />
            <path d="m32 42a9.914 9.914 0 0 1 -7.068-2.934 1 1 0 1 1 1.416-1.412 7.995 7.995 0 1 0 11.306-11.306 1 1 0 1 1 1.412-1.416 10 10 0 0 1 -7.066 17.068z" />
        </svg>
    );
};

export const CrossInCircle = ({
    fill = '#484a53',
    transform,
    width = '30',
    height = '30',
}) => {
    return (
        <svg
            viewBox="0 0 512 512"
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            fill={fill}
            transform={transform}
        >
            <path d="m256 512c-141.160156 0-256-114.839844-256-256s114.839844-256 256-256 256 114.839844 256 256-114.839844 256-256 256zm0-475.429688c-120.992188 0-219.429688 98.4375-219.429688 219.429688s98.4375 219.429688 219.429688 219.429688 219.429688-98.4375 219.429688-219.429688-98.4375-219.429688-219.429688-219.429688zm0 0" />
            <path d="m347.429688 365.714844c-4.679688 0-9.359376-1.785156-12.929688-5.359375l-182.855469-182.855469c-7.144531-7.144531-7.144531-18.714844 0-25.855469 7.140625-7.140625 18.714844-7.144531 25.855469 0l182.855469 182.855469c7.144531 7.144531 7.144531 18.714844 0 25.855469-3.570313 3.574219-8.246094 5.359375-12.925781 5.359375zm0 0" />
            <path d="m164.570312 365.714844c-4.679687 0-9.355468-1.785156-12.925781-5.359375-7.144531-7.140625-7.144531-18.714844 0-25.855469l182.855469-182.855469c7.144531-7.144531 18.714844-7.144531 25.855469 0 7.140625 7.140625 7.144531 18.714844 0 25.855469l-182.855469 182.855469c-3.570312 3.574219-8.25 5.359375-12.929688 5.359375zm0 0" />
        </svg>
    );
};

export const InProgress = ({
    fill = '#484a53',
    width = '32px',
    height = '32px',
}) => {
    return (
        <svg
            fill={fill}
            height={height}
            viewBox="0 -26 511.9992 511"
            width={width}
        >
            <path d="m506.929688 238.9375c-6.207032-5.484375-15.6875-4.894531-21.171876 1.3125l-.242187.273438v-10.511719c0-61.304688-23.875-118.941407-67.226563-162.292969-43.347656-43.347656-100.984374-67.21875-162.289062-67.21875-37.03125 0-73.828125 9.03125-106.417969 26.113281-31.53125 16.527344-59.207031 40.570313-80.035156 69.535157-4.835937 6.722656-3.304687 16.097656 3.421875 20.933593 6.726562 4.839844 16.101562 3.308594 20.9375-3.417969 18.117188-25.195312 42.1875-46.109374 69.605469-60.480468 28.308593-14.839844 60.289062-22.683594 92.488281-22.683594 110.011719 0 199.515625 89.503906 199.515625 199.515625v10.511719l-.246094-.273438c-5.484375-6.210937-14.964843-6.796875-21.171875-1.3125-6.210937 5.484375-6.796875 14.964844-1.3125 21.171875l26.484375 29.984375c2.847657 3.222656 6.941407 5.066406 11.242188 5.066406s8.394531-1.84375 11.242187-5.066406l26.484375-29.984375c5.488281-6.210937 4.902344-15.691406-1.308593-21.175781zm0 0" />
            <path d="m439.03125 342.890625c-6.726562-4.835937-16.097656-3.308594-20.9375 3.417969-18.117188 25.191406-42.1875 46.105468-69.605469 60.480468-28.308593 14.839844-60.292969 22.683594-92.488281 22.683594-110.011719 0-199.515625-89.503906-199.515625-199.515625v-10.511719l.246094.277344c5.484375 6.207032 14.964843 6.796875 21.171875 1.308594 6.210937-5.484375 6.796875-14.964844 1.3125-21.171875l-26.484375-29.984375c-2.851563-3.222656-6.941407-5.070312-11.242188-5.070312s-8.398437 1.847656-11.242187 5.070312l-26.488282 29.984375c-5.484374 6.210937-4.898437 15.6875 1.3125 21.171875 2.851563 2.523438 6.394532 3.761719 9.925782 3.761719 4.148437 0 8.28125-1.714844 11.246094-5.070313l.242187-.277344v10.511719c0 61.308594 23.875 118.941407 67.226563 162.292969 43.347656 43.351562 100.984374 67.222656 162.289062 67.222656 37.027344 0 73.828125-9.03125 106.417969-26.113281 31.527343-16.527344 59.203125-40.574219 80.03125-69.535156 4.835937-6.726563 3.308593-16.097657-3.417969-20.933594zm0 0" />
            <path d="m256 289.957031c33.082031 0 60-26.914062 60-60 0-33.082031-26.917969-60-60-60-33.085938 0-60 26.917969-60 60 0 33.085938 26.914062 60 60 60zm0-90c16.542969 0 30 13.457031 30 30s-13.457031 30-30 30-30-13.457031-30-30 13.457031-30 30-30zm0 0" />
            <path d="m108.046875 268.390625c-1.03125 3.839844-.492187 7.933594 1.5 11.378906l30 51.964844c1.988281 3.445313 5.265625 5.957031 9.105469 6.988281 3.84375 1.027344 7.9375.492188 11.382812-1.5l22.058594-12.734375c8.808594 6.882813 18.570312 12.53125 28.90625 16.726563v25.433594c0 8.28125 6.714844 15 15 15h60c8.28125 0 15-6.71875 15-15v-25.433594c10.335938-4.195313 20.097656-9.84375 28.90625-16.726563l22.058594 12.734375c3.441406 1.988282 7.539062 2.527344 11.378906 1.5 3.84375-1.03125 7.121094-3.542968 9.109375-6.988281l30-51.964844c1.988281-3.445312 2.527344-7.539062 1.5-11.378906-1.03125-3.84375-3.546875-7.121094-6.988281-9.109375l-22.105469-12.761719c.757813-5.476562 1.140625-11.019531 1.140625-16.5625 0-5.609375-.390625-11.207031-1.167969-16.746093l22.132813-12.777344c3.445312-1.988282 5.957031-5.265625 6.988281-9.109375 1.027344-3.84375.488281-7.9375-1.5-11.382813l-30-51.960937c-4.140625-7.171875-13.316406-9.628907-20.488281-5.488281l-22.203125 12.820312c-8.773438-6.832031-18.484375-12.441406-28.761719-16.613281v-25.632813c0-8.28125-6.714844-15-15-15h-60c-8.285156 0-15 6.71875-15 15v25.632813c-10.273438 4.171875-19.988281 9.78125-28.757812 16.613281l-22.207032-12.820312c-7.171875-4.144532-16.347656-1.683594-20.488281 5.488281l-30 51.960937c-1.988281 3.445313-2.527344 7.542969-1.5 11.382813 1.03125 3.84375 3.542969 7.121093 6.988281 9.109375l22.132813 12.777344c-.777344 5.539062-1.167969 11.136718-1.167969 16.746093 0 5.542969.382812 11.082031 1.140625 16.5625l-22.101563 12.761719c-3.449218 1.988281-5.960937 5.265625-6.992187 9.109375zm60.371094-17.632813c-1.605469-6.785156-2.417969-13.785156-2.417969-20.800781 0-7.066406.824219-14.113281 2.453125-20.949219 1.539063-6.453124-1.34375-13.152343-7.089844-16.46875l-18.335937-10.585937 15-25.980469 18.398437 10.625c5.742188 3.3125 12.980469 2.464844 17.800781-2.085937 10.207032-9.640625 22.671876-16.839844 36.050782-20.820313 6.359375-1.894531 10.722656-7.742187 10.722656-14.378906v-21.246094h30v21.246094c0 6.636719 4.359375 12.484375 10.71875 14.378906 13.382812 3.980469 25.847656 11.183594 36.054688 20.820313 4.820312 4.550781 12.058593 5.398437 17.796874 2.085937l18.402344-10.625 15 25.980469-18.335937 10.585937c-5.746094 3.316407-8.628907 10.015626-7.09375 16.46875 1.628906 6.835938 2.457031 13.882813 2.457031 20.949219 0 7.015625-.816406 14.015625-2.417969 20.800781-1.523437 6.449219 1.359375 13.128907 7.097657 16.441407l18.292968 10.5625-15 25.980469-18.265625-10.546876c-5.75-3.320312-13-2.464843-17.820312 2.101563-10.226563 9.691406-22.734375 16.929687-36.164063 20.929687-6.363281 1.890626-10.722656 7.738282-10.722656 14.375v21.046876h-30v-21.046876c0-6.636718-4.359375-12.484374-10.71875-14.375-13.433594-4-25.941406-11.234374-36.167969-20.929687-4.820312-4.566406-12.066406-5.417969-17.816406-2.101563l-18.269531 10.546876-15-25.980469 18.292968-10.5625c5.734376-3.3125 8.621094-9.992188 7.097657-16.441407zm0 0" />
        </svg>
    );
};

export const ArrowLeft = ({ fill = '#4c72bd' }) => {
    return (
        <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="20"
            fill={fill}
            viewBox="0 0 492 492"
        >
            <g>
                <g>
                    <path
                        d="M464.344,207.418l0.768,0.168H135.888l103.496-103.724c5.068-5.064,7.848-11.924,7.848-19.124
			c0-7.2-2.78-14.012-7.848-19.088L223.28,49.538c-5.064-5.064-11.812-7.864-19.008-7.864c-7.2,0-13.952,2.78-19.016,7.844
			L7.844,226.914C2.76,231.998-0.02,238.77,0,245.974c-0.02,7.244,2.76,14.02,7.844,19.096l177.412,177.412
			c5.064,5.06,11.812,7.844,19.016,7.844c7.196,0,13.944-2.788,19.008-7.844l16.104-16.112c5.068-5.056,7.848-11.808,7.848-19.008
			c0-7.196-2.78-13.592-7.848-18.652L134.72,284.406h329.992c14.828,0,27.288-12.78,27.288-27.6v-22.788
			C492,219.198,479.172,207.418,464.344,207.418z"
                    />
                </g>
            </g>
        </svg>
    );
};

export const ArrowRight = ({ fill = '#000000', className = '' }) => {
    return (
        <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            widths="16"
            fill={fill}
            height="16"
            viewBox="0 0 492 492"
            className={className}
        >
            <path d="M506.134 241.843l-.018-.019-104.504-104c-7.829-7.791-20.492-7.762-28.285.068-7.792 7.829-7.762 20.492.067 28.284L443.558 236H20c-11.046 0-20 8.954-20 20s8.954 20 20 20h423.557l-70.162 69.824c-7.829 7.792-7.859 20.455-.067 28.284 7.793 7.831 20.457 7.858 28.285.068l104.504-104 .018-.019c7.833-7.818 7.808-20.522-.001-28.314z" />
        </svg>
    );
};

export const Check = ({ fill, height, width, className }) => {
    return (
        <svg
            className={className}
            height={height}
            viewBox="0 -46 417.81333 417"
            width={width}
            fill={fill}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="m159.988281 318.582031c-3.988281 4.011719-9.429687 6.25-15.082031 6.25s-11.09375-2.238281-15.082031-6.25l-120.449219-120.46875c-12.5-12.5-12.5-32.769531 0-45.246093l15.082031-15.085938c12.503907-12.5 32.75-12.5 45.25 0l75.199219 75.203125 203.199219-203.203125c12.503906-12.5 32.769531-12.5 45.25 0l15.082031 15.085938c12.5 12.5 12.5 32.765624 0 45.246093zm0 0" />
        </svg>
    );
};

export const Github = ({ width = '30px', height = '30px' }) => {
    return (
        <svg
            viewBox="0 0 33 33"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            widths={width}
            height={height}
        >
            <defs>
                <path id="github-icon" d="M0 0v31.775h32.579V0z"></path>
            </defs>
            <g transform="translate(0 .5)" fill="none" fillRule="evenodd">
                <mask id="b" fill="#fff">
                    <use xlinkHref="#github-icon"></use>
                </mask>
                <path
                    d="M16.289 0C7.294 0-.001 7.293-.001 16.291c0 7.196 4.668 13.301 11.142 15.456.815.149 1.112-.354 1.112-.786 0-.386-.014-1.411-.022-2.77-4.531.984-5.487-2.184-5.487-2.184-.741-1.882-1.81-2.382-1.81-2.382-1.478-1.011.113-.991.113-.991 1.635.116 2.495 1.679 2.495 1.679 1.453 2.489 3.812 1.77 4.74 1.354.149-1.053.569-1.771 1.035-2.178-3.617-.411-7.42-1.809-7.42-8.051 0-1.778.635-3.232 1.677-4.371-.168-.412-.727-2.068.159-4.311 0 0 1.368-.438 4.48 1.67a15.602 15.602 0 0 1 4.078-.549c1.383.007 2.777.187 4.078.549 3.11-2.108 4.475-1.67 4.475-1.67.889 2.243.33 3.899.162 4.311 1.044 1.139 1.675 2.593 1.675 4.371 0 6.258-3.81 7.635-7.438 8.038.585.503 1.106 1.497 1.106 3.017 0 2.177-.02 3.934-.02 4.468 0 .436.293.943 1.12.784 6.467-2.159 11.13-8.26 11.13-15.454C32.58 7.293 25.287 0 16.29 0"
                    fill="#181717"
                    mask="url(#b)"
                ></path>
            </g>
        </svg>
    );
};

export const Gitlab = ({ width = '30px', height = '30px' }) => {
    return (
        <svg
            widths={width}
            height={height}
            viewBox="0 0 34 32"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g fill="none">
                <path
                    d="M33.61 18.309l-1.85-5.686-3.667-11.268c-.189-.58-1.01-.58-1.2 0l-3.666 11.268H11.052L7.385 1.355c-.188-.58-1.01-.58-1.199 0L2.52 12.623.67 18.31a1.258 1.258 0 0 0 .458 1.407L17.14 31.333l16.01-11.617c.442-.32.627-.889.458-1.407"
                    fill="#FC6D26"
                ></path>
                <path
                    d="M17.14 31.333l6.087-18.71H11.052z"
                    fill="#E24329"
                ></path>
                <path
                    d="M17.14 31.333l-6.088-18.71H2.52z"
                    fill="#FC6D26"
                ></path>
                <path
                    d="M2.52 12.623L.67 18.31a1.257 1.257 0 0 0 .458 1.407L17.14 31.333 2.52 12.623z"
                    fill="#FCA326"
                ></path>
                <path
                    d="M2.52 12.623h8.532L7.385 1.355c-.189-.58-1.01-.58-1.199 0L2.52 12.623z"
                    fill="#E24329"
                ></path>
                <path
                    d="M17.14 31.333l6.087-18.71h8.532z"
                    fill="#FC6D26"
                ></path>
                <path
                    d="M31.76 12.623l1.85 5.686a1.257 1.257 0 0 1-.459 1.407L17.14 31.333l14.62-18.71z"
                    fill="#FCA326"
                ></path>
                <path
                    d="M31.76 12.623h-8.533l3.667-11.268c.189-.58 1.01-.58 1.199 0l3.666 11.268z"
                    fill="#E24329"
                ></path>
            </g>
        </svg>
    );
};

export const Bitbucket = ({ width = '30px', height = '30px' }) => {
    return (
        <svg
            widths={width}
            height={height}
            viewBox="0 0 64 65"
            xmlns="http://www.w3.org/2000/svg"
        >
            <defs>
                <linearGradient
                    x1="108.633%"
                    y1="13.818%"
                    x2="46.927%"
                    y2="78.776%"
                    id="a"
                >
                    <stop stopColor="#0052CC" offset="18%"></stop>
                    <stop stopColor="#2684FF" offset="100%"></stop>
                </linearGradient>
            </defs>
            <g fill="none" fillRule="evenodd">
                <path d="M25.7 42.51h13.05l3.15-18.39H22.23z"></path>
                <path
                    d="M3 5.26a2 2 0 0 0-2 2.32l8.49 51.54a2.72 2.72 0 0 0 2.66 2.27h40.73a2 2 0 0 0 2-1.68l8.49-52.12a2 2 0 0 0-2-2.32L3 5.26zm35.75 37.25h-13l-3.52-18.39H41.9l-3.15 18.39z"
                    fill="#2684FF"
                    fillRule="nonzero"
                ></path>
                <path
                    d="M60.67 19.12H41.9l-3.15 18.39h-13L10.4 55.73a2.71 2.71 0 0 0 1.75.66h40.74a2 2 0 0 0 2-1.68l5.78-35.59z"
                    fill="url(#a)"
                    transform="translate(0 5)"
                ></path>
            </g>
        </svg>
    );
};

export const DeleteIcon = ({ height = 22, width = 22, className = '' }) => {
    return (
        <svg
            className={className}
            height={height}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M14.87 12c1.3 0 2.55.58 3.46 1.61a5.86 5.86 0 0 1 1.44 3.89c0 1.46-.52 2.86-1.44 3.89A4.65 4.65 0 0 1 14.87 23c-1.3 0-2.55-.58-3.47-1.61a5.86 5.86 0 0 1-1.44-3.89c0-1.46.52-2.86 1.44-3.89A4.65 4.65 0 0 1 14.87 12ZM10.86 1.75c.74 0 1.45.32 1.99.89.53.57.86 1.35.9 2.18V5h4.68c.17 0 .34.07.46.2s.2.3.21.5a.81.81 0 0 1-.15.52.65.65 0 0 1-.43.27l-.09.01h-.7l-.45 5.09a5.32 5.32 0 0 0-1.3-.47l.4-4.62H5.33l1.13 12.87c.02.29.14.56.32.76.18.2.42.33.67.36l.12.01h2.16c.25.55.58 1.06.96 1.5H7.57a2.3 2.3 0 0 1-1.59-.65c-.44-.43-.74-1.01-.83-1.66l-.02-.17L3.99 6.5h-.71a.63.63 0 0 1-.44-.18.78.78 0 0 1-.23-.47v-.1a.8.8 0 0 1 .16-.5c.1-.13.26-.22.42-.24L3.28 5h4.68c0-.86.3-1.69.85-2.3.54-.6 1.28-.95 2.05-.95Zm1.53 12.84-.07.06-.05.07a.54.54 0 0 0 0 .56l.05.07 1.92 2.15-1.92 2.15-.05.07a.54.54 0 0 0 0 .56l.05.07.07.06c.07.06.16.09.25.09s.18-.03.25-.09l.06-.06 1.92-2.14 1.91 2.14.06.06a.41.41 0 0 0 .5 0l.07-.06.05-.07a.54.54 0 0 0 0-.56l-.05-.07-1.91-2.15 1.91-2.15.05-.07a.54.54 0 0 0 0-.56l-.05-.07-.06-.06a.41.41 0 0 0-.25-.09.41.41 0 0 0-.26.09l-.06.06-1.91 2.14-1.92-2.14-.06-.06a.4.4 0 0 0-.44-.04l-.06.04ZM10.86 3.25c-.4 0-.77.17-1.06.46-.29.3-.47.7-.5 1.15V5h3.12c0-.46-.17-.9-.46-1.24-.3-.33-.7-.51-1.1-.51Z" />
        </svg>
    );
};
export const StoryIcon = ({ title }) => {
    return (
        <svg
            width="20"
            height="20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>{title}</title>
            <rect width="20" height="20" rx="3" fill="#02B961" />
            <g clipPath="url(#clip0)">
                <path
                    d="M14.62 14.7c.38-.3.63-.8.63-1.37V4.17c0-.92-.68-1.67-1.5-1.67h-7.5c-.83 0-1.5.75-1.5 1.67v9.16c0 .56.25 1.06.63 1.36L10 18.33l4.62-3.64z"
                    fill="#fff"
                />
            </g>
            <defs>
                <clipPath id="clip0">
                    <path
                        fill="#fff"
                        transform="rotate(90 9.5 9.5)"
                        d="M0 0h20v18H0z"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export const TaskIcon = ({ title }) => {
    return (
        <svg
            width="20"
            height="20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>{title}</title>
            <rect width="20" height="20" rx="3" fill="#4C72BD" />
            <path
                d="M9.25 8.38v6.87h-5A1.25 1.25 0 013 14V5.25A1.25 1.25 0 014.25 4H13a1.25 1.25 0 011.25 1.25v3.13h-5zM8 8.38H4.25v2.5H8v-2.5zM8 14v-1.88H4.25V14H8zm1.25-8.75v1.88H13V5.25H9.25zM8 5.25H4.25v1.88H8V5.25z"
                fill="#fff"
            />
            <path
                d="M13 15.25v-1.88h-1.88v-1.24H13v-1.88h1.25v1.88h1.88v1.24h-1.88v1.88H13z"
                fill="#fff"
            />
        </svg>
    );
};

export const BugIcon = ({ title }) => {
    return (
        <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
            <title>{title}</title>
            <rect width="20" height="20" rx="3" fill="#DB2020" />
            <path
                d="M7.33 5.4L9 6.33l-.93-1.66L9 3l-1.67.93L5.67 3l.93 1.67-.93 1.66 1.66-.93zm8 6.53L13.67 11l.93 1.67-.93 1.66 1.66-.93 1.67.93-.93-1.66L17 11l-1.67.93zM17 3l-1.67.93L13.67 3l.93 1.67-.93 1.66 1.66-.93 1.67.93-.93-1.66L17 3zm-5.09 3.53a.66.66 0 00-.94 0L3.2 14.3a.66.66 0 000 .94l1.56 1.55c.26.27.68.27.94 0l7.78-7.77a.66.66 0 000-.94L11.9 6.53zm-.68 3.66L9.8 8.77l1.63-1.62 1.41 1.4-1.62 1.64z"
                fill="#fff"
            />
        </svg>
    );
};

export const SubtaskIocn = ({ title }) => {
    return (
        <svg
            width="20"
            height="20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>{title}</title>
            <rect width="20" height="20" rx="3" fill="#C6349D" />
            <path
                d="M4 7h6M2 3h4M4 3v11a1 1 0 0 0 1 1h5M17 5h-6a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1ZM17 13h-6a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1Z"
                stroke="#fff"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const EpicIcon = ({ title }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 512 512"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>{title}</title>
            <rect width="512" height="512" rx="60" fill="#7902D7" />
            <path
                d="M397.41 199.3c-2.94-4.57-8-7.3-13.4-7.3H272V16A16 16 0 0 0 259.32.37a15.93 15.93 0 0 0-17.95 9.15l-128 288a15.96 15.96 0 0 0 1.22 15.2 16 16 0 0 0 13.4 7.3h112v176a16 16 0 0 0 30.63 6.5l128-288a15.96 15.96 0 0 0-1.22-15.2z"
                fill="#FFFFFF"
            />
        </svg>
    );
};

export const EditIcon = ({
    className = '',
    height = 22,
    width = 22,
    ...otherPorps
}) => {
    return (
        <svg
            className={className}
            height={height}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
            {...otherPorps}
        >
            <path d="M17.67.2a.69.69 0 0 0-.97 0l-2.26 2.27 5.1 5.1L21.8 5.3a.69.69 0 0 0 0-.97L17.67.2Zm.9 8.34-5.1-5.1-8.94 8.94h.28a.69.69 0 0 1 .69.68v.69h.69a.69.69 0 0 1 .68.69v.69h.7a.69.69 0 0 1 .68.68v.69h.69a.69.69 0 0 1 .68.69v.28l8.94-8.93ZM8.28 18.8a.69.69 0 0 1-.04-.24v-.68h-.69a.69.69 0 0 1-.69-.7v-.68H6.2a.69.69 0 0 1-.7-.69v-.68h-.68a.69.69 0 0 1-.69-.7v-.68h-.68a.69.69 0 0 1-.24-.04l-.25.24a.69.69 0 0 0-.15.23L.05 21.06a.69.69 0 0 0 .9.9l6.87-2.76a.69.69 0 0 0 .23-.15l.24-.25Z" />
        </svg>
    );
};

export const RevertIcon = ({
    className = '',
    height = 22,
    width = 22,
    ...otherPorps
}) => {
    return (
        <svg
            className={className}
            height={height}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
            {...otherPorps}
        >
            <path
                d="M14 27H18C19.0506 27 20.0909 26.7809 21.0615 26.3552C22.0321 25.9295 22.914 25.3056 23.6569 24.519C24.3997 23.7325 24.989 22.7987 25.391 21.771C25.7931 20.7433 26 19.6418 26 18.5294C26 17.417 25.7931 16.3156 25.391 15.2879C24.989 14.2602 24.3997 13.3264 23.6569 12.5398C22.914 11.7532 22.0321 11.1293 21.0615 10.7036C20.0909 10.2779 19.0506 10.0588 18 10.0588H3.33333M8.66667 3L2 10.0588L8.66667 17.1176V3Z"
                stroke="#FF6384"
                strokeWidth="2"
            />
        </svg>
    );
};

export const SaveIcon = ({
    className = '',
    height = 22,
    width = 22,
    ...otherPorps
}) => {
    return (
        <svg
            className={className}
            height={height}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
            {...otherPorps}
        >
            <path d="M2.81 24h18.67a2.67 2.67 0 0 0 2.67-2.67V6.67L17.48 0H2.81A2.67 2.67 0 0 0 .15 2.67v18.66A2.67 2.67 0 0 0 2.8 24ZM5.48 2.67h5.33v2.66h2.67V2.67h2.67V8H5.48V2.67Zm0 10.66h13.33v8H5.48v-8Z" />
        </svg>
    );
};

export const CalendarIcon = ({
    width = 18,
    height = 20,
    className = '',
    fill = '#fff',
}) => {
    return (
        <svg
            className={className}
            height={height}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
            fill={fill}
        >
            <path
                d="M4 9H6V11H4V9ZM18 4V18C18 19.1 17.1 20 16 20H2C1.46957 20 0.960859 19.7893 0.585786 19.4142C0.210714 19.0391 0 18.5304 0 18L0.00999999 4C0.00999999 2.9 0.89 2 2 2H3V0H5V2H13V0H15V2H16C17.1 2 18 2.9 18 4ZM2 6H16V4H2V6ZM16 18V8H2V18H16ZM12 11H14V9H12V11ZM8 11H10V9H8V11Z"
                fill={fill}
            />
        </svg>
    );
};

export const BurgerMenuIcon = ({
    width = 28,
    height = 28,
    fill = '#7F8992',
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height={width}
            viewBox="0 0 24 24"
            width={height}
            fill={fill}
        >
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
        </svg>
    );
};

export const AzureDevOpsIcon = ({
    width = '18px',
    height = '14px',
    fill = '#0072c6',
}) => {
    return (
        <svg
            height={height}
            viewBox="0 0 59.242 47.271"
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="m32.368 0-17.468 15.145-14.9 26.75h13.437zm2.323 3.543-7.454 21.008 14.291 17.956-27.728 4.764h45.442z"
                fill={fill}
            />
        </svg>
    );
};

export const JiraIcon = ({ width = '18px', height = '18px' }) => {
    return (
        <svg
            height={width}
            preserveAspectRatio="xMidYMid"
            width={height}
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 -30.632388516510233 255.324 285.95638851651023"
        >
            <linearGradient id="a">
                <stop offset=".18" stopColor="#0052cc" />
                <stop offset="1" stopColor="#2684ff" />
            </linearGradient>
            <linearGradient
                id="b"
                x1="98.031%"
                x2="58.888%"
                xlinkHref="#a"
                y1=".161%"
                y2="40.766%"
            />
            <linearGradient
                id="c"
                x1="100.665%"
                x2="55.402%"
                xlinkHref="#a"
                y1=".455%"
                y2="44.727%"
            />
            <path
                d="M244.658 0H121.707a55.502 55.502 0 0 0 55.502 55.502h22.649V77.37c.02 30.625 24.841 55.447 55.466 55.467V10.666C255.324 4.777 250.55 0 244.658 0z"
                fill="#2684ff"
            />
            <path
                d="M183.822 61.262H60.872c.019 30.625 24.84 55.447 55.466 55.467h22.649v21.938c.039 30.625 24.877 55.43 55.502 55.43V71.93c0-5.891-4.776-10.667-10.667-10.667z"
                fill="url(#b)"
            />
            <path
                d="M122.951 122.489H0c0 30.653 24.85 55.502 55.502 55.502h22.72v21.867c.02 30.597 24.798 55.408 55.396 55.466V133.156c0-5.891-4.776-10.667-10.667-10.667z"
                fill="url(#c)"
            />
        </svg>
    );
};

export const EqualIcon = ({ width = 30, height = 30, fill = '#1FB8D3' }) => {
    return (
        <svg
            width={width}
            height={height}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="28" height="28" fill={fill} />
            <path
                d="M25.5841 13.6834L22.5047 11.1382C22.428 11.0731 22.3294 11.0283 22.2217 11.0097C22.114 10.9911 22.002 10.9994 21.9001 11.0337C21.7981 11.068 21.7109 11.1266 21.6495 11.2022C21.5882 11.2777 21.5554 11.3666 21.5556 11.4575V13.0904H6.1037C5.49667 13.0904 5 13.501 5 14.0027C5 14.5044 5.49667 14.9149 6.1037 14.9149H21.5556V16.5479C21.5556 16.9584 22.1516 17.1591 22.4937 16.8671L25.573 14.322C25.7938 14.1487 25.7938 13.8567 25.5841 13.6834Z"
                fill="white"
            />
            <rect x="2" y="3" width="2" height="21" rx="1" fill="white" />
            <path
                d="M3 24C2.44772 24 2 23.5523 2 23L2 22L25 22C25.5523 22 26 22.4477 26 23V23C26 23.5523 25.5523 24 25 24L3 24Z"
                fill="white"
            />
        </svg>
    );
};

export const LessIcon = ({ width = 30, height = 30, fill = '#E37F22' }) => {
    return (
        <svg
            width={width}
            height={height}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="28" height="28" fill={fill} />
            <rect x="2" y="3" width="2" height="21" rx="1" fill="white" />
            <path
                d="M3 24C2.44772 24 2 23.5523 2 23L2 22L25 22C25.5523 22 26 22.4477 26 23V23C26 23.5523 25.5523 24 25 24L3 24Z"
                fill="white"
            />
            <path
                d="M20.1679 18.2898L21.6813 16.7763L16.5525 11.6475L13.0947 15.1053C12.9975 15.2027 12.882 15.28 12.7549 15.3327C12.6277 15.3855 12.4914 15.4126 12.3538 15.4126C12.2162 15.4126 12.0799 15.3855 11.9527 15.3327C11.8256 15.28 11.7101 15.2027 11.6129 15.1053L5.30691 8.78881C5.1104 8.59229 5 8.32577 5 8.04786C5 7.76995 5.1104 7.50342 5.30691 7.30691C5.50342 7.1104 5.76995 7 6.04786 7C6.32577 7 6.59229 7.1104 6.78881 7.30691L12.3485 12.8772L15.8063 9.4194C15.9035 9.32197 16.019 9.24467 16.1462 9.19193C16.2733 9.13919 16.4096 9.11205 16.5472 9.11205C16.6849 9.11205 16.8212 9.13919 16.9483 9.19193C17.0755 9.24467 17.191 9.32197 17.2882 9.4194L23.1632 15.2839L24.6767 13.7705C24.7501 13.6985 24.8431 13.6496 24.944 13.6299C25.045 13.6103 25.1495 13.6206 25.2446 13.6598C25.3398 13.699 25.4213 13.7652 25.4791 13.8503C25.537 13.9353 25.5686 14.0355 25.57 14.1383V18.6471C25.57 18.9414 25.3388 19.1726 25.0445 19.1726H20.5358C20.0733 19.1831 19.8421 18.6156 20.1679 18.2898V18.2898Z"
                fill="white"
            />
        </svg>
    );
};

export const GreaterIcon = ({ width = 30, height = 30, fill = '#518B14' }) => {
    return (
        <svg
            width={width}
            height={height}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="28" height="28" fill={fill} />
            <rect x="2" y="3" width="2" height="21" rx="1" fill="white" />
            <path
                d="M3 24C2.44772 24 2 23.5523 2 23L2 22L25 22C25.5523 22 26 22.4477 26 23V23C26 23.5523 25.5523 24 25 24L3 24Z"
                fill="white"
            />
            <path
                d="M20.1676 7.89355L21.681 9.40714L16.5523 14.5365L13.0946 11.0784C12.9973 10.9809 12.8819 10.9036 12.7547 10.8509C12.6276 10.7981 12.4913 10.771 12.3536 10.771C12.216 10.771 12.0797 10.7981 11.9526 10.8509C11.8254 10.9036 11.7099 10.9809 11.6127 11.0784L5.3069 17.3955C5.2096 17.4928 5.13242 17.6083 5.07976 17.7355C5.0271 17.8626 5 17.9989 5 18.1365C5 18.2741 5.0271 18.4104 5.07976 18.5375C5.13242 18.6647 5.2096 18.7802 5.3069 18.8775C5.4042 18.9748 5.51972 19.052 5.64685 19.1047C5.77398 19.1574 5.91023 19.1845 6.04784 19.1845C6.18544 19.1845 6.3217 19.1574 6.44883 19.1047C6.57596 19.052 6.69147 18.9748 6.78877 18.8775L12.3484 13.3067L15.8061 16.7648C16.2159 17.1748 16.8781 17.1748 17.2879 16.7648L23.1628 10.8997L24.6762 12.4133C24.7497 12.4853 24.8426 12.5342 24.9436 12.5539C25.0446 12.5735 25.1491 12.5631 25.2442 12.524C25.3393 12.4848 25.4208 12.4186 25.4787 12.3335C25.5365 12.2484 25.5681 12.1483 25.5696 12.0454V7.52567C25.5724 7.45677 25.5612 7.38801 25.5365 7.32364C25.5117 7.25927 25.4741 7.20064 25.4258 7.15139C25.3776 7.10214 25.3197 7.06331 25.2559 7.03729C25.192 7.01127 25.1235 6.99862 25.0546 7.00012H20.5459C20.4422 6.99951 20.3406 7.02963 20.2539 7.08668C20.1673 7.14373 20.0994 7.22515 20.059 7.3207C20.0185 7.41624 20.0072 7.52163 20.0266 7.62357C20.0459 7.72551 20.095 7.81945 20.1676 7.89355V7.89355Z"
                fill="white"
            />
        </svg>
    );
};

export const GoogleCloudPlatformIcon = ({
    width = '18px',
    height = '18px',
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 80 80"
            fill="#fff"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            width={width}
            height={height}
        >
            <use xlinkHref="#A" x=".5" y=".5" />
            <symbol id="A" overflow="visible">
                <g stroke="none">
                    <path
                        d="M50.764 17.729h2.439l6.953-6.954.341-2.953C47.556-3.602 27.805-2.368 16.381 10.574c-3.174 3.592-5.474 7.871-6.733 12.5.773-.317 1.633-.37 2.44-.144l13.907-2.295s.706-1.172 1.076-1.1a17.35 17.35 0 0 1 23.742-1.806h-.048z"
                        fill="#ea4335"
                    />
                    <path
                        d="M70.064 23.074a31.3 31.3 0 0 0-9.441-15.223l-9.758 9.758a17.35 17.35 0 0 1 6.368 13.763v1.734a8.69 8.69 0 0 1 8.687 8.687 8.69 8.69 0 0 1-8.687 8.687H39.859l-1.734 1.758v10.421l1.734 1.734h17.374c12.476.096 22.671-9.94 22.767-22.416a22.6 22.6 0 0 0-9.936-18.901z"
                        fill="#4285f4"
                    />
                    <path
                        d="M22.46 64.282h17.374V50.375H22.46a8.65 8.65 0 0 1-3.587-.783l-2.44.759-7.002 6.954-.61 2.439c3.923 2.968 8.716 4.562 13.638 4.538z"
                        fill="#34a853"
                    />
                    <path
                        d="M22.46 19.17C9.979 19.242-.072 29.418 0 41.899a22.58 22.58 0 0 0 8.822 17.773l10.075-10.075a8.69 8.69 0 0 1-4.341-11.492 8.69 8.69 0 0 1 11.492-4.341c1.926.869 3.467 2.415 4.341 4.341L40.463 28.03a22.54 22.54 0 0 0-18.003-8.86z"
                        fill="#fbbc05"
                    />
                </g>
            </symbol>
        </svg>
    );
};

export const AWSCloudWatchIcon = ({ width = '18px', height = '18px' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="3.62 8.78 64 64"
            width={width}
            height={height}
        >
            <path
                d="M35.605 72.78L63.9 52.803l-28.266-4.13-28.296 4.16z"
                fill="#b7ca9d"
            />
            <path
                d="M12.986 21.167v31.18l4.797 1.427L29.017 36.56 17.783 19.315z"
                fill="#4c622c"
            />
            <path d="M34.694 23.14v27.72l-16.9 2.975v-34.52z" fill="#759c3f" />
            <path
                d="M46.686 33.98l-19.52 22.68-6.62-2.004V12.1l6.62-3.3z"
                fill="#4c622c"
            />
            <path d="M49.753 17.585v33.822L27.165 56.7V8.78z" fill="#759c3f" />
            <path d="M35.605 72.78v-9.928L7.34 52.833v5.8z" fill="#4c622c" />
            <path d="M63.9 52.803v5.83L35.605 72.78v-9.928z" fill="#759c3f" />
            <path
                d="M35.605 59.178l20.342-16h-6.86l-19.522 1.336z"
                fill="#b7ca9d"
            />
            <path
                d="M29.563 44.514v12.842l6.042 1.822V45.152z"
                fill="#4c622c"
            />
            <path
                d="M55.946 53.076v-9.898L35.604 45.15v14.027z"
                fill="#759c3f"
            />
        </svg>
    );
};

export const PrometheusIcon = ({
    width = '18px',
    height = '18px',
    fill = '#da4e31',
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="-4.649 -0.667 64 64"
            overflow="visible"
        >
            <path
                d="M27.35-.667c-17.673 0-32 14.326-32 32s14.328 32 32 32 32-14.327 32-32-14.328-32-32-32zm0 59.89c-5.028 0-9.105-3.36-9.105-7.5h18.2c0 4.142-4.077 7.5-9.105 7.5zM42.4 49.24H12.31v-5.454H42.4v5.454zm-.108-8.26H12.397l-.297-.344c-3.08-3.74-3.804-5.7-4.508-7.68-.012-.066 3.734.766 6.39 1.363 0 0 1.367.316 3.364.68-1.918-2.25-3.057-5.107-3.057-8.03 0-6.415 4.92-12.02 3.145-16.55 1.728.14 3.575 3.646 3.7 9.126 1.837-2.538 2.605-7.172 2.605-10.014 0-2.942 1.94-6.36 3.878-6.477-1.73 2.85.448 5.29 2.382 11.35.726 2.276.633 6.106 1.193 8.535.186-5.045 1.053-12.405 4.254-14.946-1.412 3.2.21 7.205 1.318 9.13 1.79 3.106 2.873 5.46 2.873 9.9 0 2.984-1.102 5.793-2.96 8 2.113-.397 3.572-.754 3.572-.754l6.862-1.34c0-.001-.997 4.1-4.828 8.05z"
                fill={fill}
            />
        </svg>
    );
};

export const DatadogIcon = ({ width = '18px', height = '18px' }) => {
    return (
        <svg
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24 "
            width={width}
            height={height}
        >
            <path d="M19.55 17.04l-1.99-1.32-1.66 2.78-1.93-.57-1.7 2.6.09.82 9.25-1.71-.54-5.79-1.52 3.19zm-8.63-2.5l1.48-.2c.24.11.41.15.69.22.45.12.97.23 1.74-.16.18-.09.55-.43.7-.63l6.08-1.11.62 7.53-10.41 1.88-.9-7.53zm11.29-2.71l-.6.11L20.46 0 .82 2.28l2.42 19.69 2.3-.33c-.18-.26-.47-.58-.96-.99-.68-.56-.44-1.52-.04-2.13.53-1.02 3.25-2.32 3.1-3.96-.06-.59-.15-1.37-.7-1.9-.02.22.02.43.02.43s-.23-.29-.34-.68c-.11-.15-.2-.2-.32-.4-.08.23-.07.5-.07.5s-.18-.44-.21-.81c-.11.17-.14.48-.14.48s-.24-.69-.19-1.06c-.11-.32-.43-.97-.34-2.42.6.42 1.92.32 2.43-.44.17-.24.29-.93-.08-2.28-.24-.87-.83-2.16-1.07-2.65l-.02.02c.12.4.37 1.22.47 1.63.29 1.22.37 1.64.23 2.2-.12.49-.4.81-1.1 1.16-.71.36-1.65-.51-1.71-.56-.69-.55-1.22-1.45-1.28-1.88-.06-.48.27-.77.44-1.16-.24.07-.51.2-.51.2s.32-.34.72-.63c.16-.11.26-.18.43-.32h-.46s.43-.22.86-.39c-.32-.01-.62 0-.62 0s.93-.42 1.67-.73c.51-.21 1-.15 1.28.26.37.53.75.82 1.56 1 .51-.23.66-.34 1.29-.51.55-.61.99-.69.99-.69s-.22.2-.27.51c.31-.25.66-.45.66-.45s-.13.16-.26.43l.03.04c.37-.22.8-.39.8-.39l-.27.36c.28 0 .84.01 1.05.04 1.28.03 1.55-1.37 2.04-1.55.62-.22.89-.35 1.94.68.9.89 1.6 2.48 1.25 2.83-.29.3-.87-.12-1.51-.92-.34-.42-.59-.93-.71-1.56-.1-.54-.49-.85-.49-.85s.23.51.23.96c0 .25.03 1.16.42 1.68-.04.08-.06.37-.1.43-.46-.55-1.44-.95-1.6-1.07.54.45 1.79 1.47 2.27 2.45.45.93.19 1.78.41 2 .07.06.97 1.2 1.15 1.77.3.99.02 2.04-.38 2.69l-1.11.17c-.16-.05-.27-.07-.42-.15.08-.14.24-.5.24-.57l-.06-.11c-.35.49-.93.97-1.41 1.25-.63.36-1.36.3-1.83.16-1.34-.42-2.62-1.33-2.92-1.57 0 0-.01.19.05.23.34.38 1.12 1.08 1.87 1.56l-1.6.18.76 5.91c-.34.05-.39.07-.75.12-.32-1.15-.94-1.9-1.62-2.33-.6-.38-1.42-.47-2.21-.31l-.05.06c.55-.06 1.19.02 1.86.44.65.41 1.18 1.48 1.37 2.12.25.82.42 1.7-.25 2.63-.47.66-1.86 1.03-2.98.24.3.48.7.88 1.25.95.81.11 1.57-.03 2.1-.57.45-.46.69-1.43.63-2.46l.71-.1.26 1.83 11.79-1.42-1-9.44zm-7.17-4.98c-.03.08-.08.12-.01.37v.01l.01.03.03.07c.14.29.29.56.55.7.07-.01.14-.02.21-.02.24-.01.39.03.49.08.01-.05.01-.12.01-.22-.02-.36.07-.98-.62-1.31-.26-.12-.63-.08-.75.07.02 0 .04.01.06.01.18.07.05.13.02.21m1.95 3.39c-.09-.05-.52-.03-.82.01-.57.07-1.19.27-1.32.37-.25.19-.13.52.05.66.51.38.96.64 1.43.58.29-.04.54-.5.73-.91.11-.3.11-.61-.07-.71M11.93 7.3c.16-.15-.8-.36-1.55.16-.55.37-.57 1.18-.04 1.64.05.05.1.08.14.1a4.857 4.857 0 011.39-.41c.11-.13.24-.35.21-.75-.05-.53-.46-.45-.15-.74" />
        </svg>
    );
};

export const DynatraceIcon = ({ width = '18px', height = '18px' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 51200 9088"
            width={width}
            height={height}
        >
            <path
                d="M17374.69-16768.765c-658.026 3472.92-1462.28 8627.467-1900.97 13855.13-767.7 9212.38-292.45 15390.52-292.45 15390.52L2203.514 24796.61s-987.04-6909.283-1498.838-14695.935C412.225 5275.144 302.548 1034.526 302.548-1524.47c0-146.226 73.113-292.458 73.113-438.684 0-182.782 219.338-1900.97 1900.97-3509.48 1827.842-1754.73 15317.397-12319.725 15098.06-11296.13"
                fill="#3a8aca"
            />
            <path
                d="M17374.69-16768.765c-658.026 3472.92-1462.28 8627.467-1900.97 13855.13 0 0-14366.927-1718.187-15171.182 1754.744 0-182.782 255.895-2303.1 1937.562-3911.608 1827.816-1754.744 15353.928-12721.86 15134.6-11698.266"
                fill="#262424"
            />
            <path
                d="M302.537-1999.7v804.255c146.226-621.47 402.128-1060.154 913.928-1754.736 1060.154-1352.612 2778.337-1718.187 3472.92-1791.3 3509.48-475.244 8700.58-1023.597 13928.243-1169.827 9248.936-292.45 15353.964 475.24 15353.964 475.24l12977.755-12319.725s-6799.614-1279.496-14549.71-2193.384c-5081.43-621.47-9541.39-950.485-12063.83-1096.714-182.782 0-1974.082-219.338-3655.705 1389.17L1837.935-5545.743C156.312-3937.232 302.537-2145.936 302.537-1999.7"
                fill="#c8d643"
            />
            <path
                d="M46474.103 13756.386c-3509.48 475.24-8700.583 1060.154-13928.243 1242.94-9248.936 292.45-15390.524-475.24-15390.524-475.24L4177.58 26880.366s6872.727 1352.612 14622.825 2229.977c4752.416 548.357 8956.478 840.812 11515.473 987.04 182.782 0 475.24-146.226 658.026-146.226s1974.082-329.015 3655.705-1937.562c1827.856-1754.736 12868.085-14366.92 11844.492-14257.25"
                fill="#63308c"
            />
            <path
                d="M46474.107 13756.386c-3509.476 475.24-8700.58 1060.154-13928.243 1242.94 0 0 987.04 14440.04-2485.88 15061.51 182.782 0 2558.995-109.67 4240.615-1718.187 1827.856-1754.744 13197.1-14695.938 12173.5-14586.27"
                fill="#262424"
            />
            <path
                d="M30827.68 30133.947c-255.895 0-511.797-36.556-804.255-36.556 658.03-109.67 1096.714-329.015 1791.3-840.812 1389.17-987.04 1827.856-2705.224 1974.082-3399.807 621.47-3472.92 1462.28-8627.467 1864.413-13855.13 731.143-9212.38 292.458-15353.964 292.458-15353.964l12977.755-12356.29s950.485 6872.73 1498.838 14659.382c329.015 5081.43 438.684 9577.95 475.24 12063.83 0 182.782 146.226 1974.082-1535.394 3582.593L34556.51 28744.81c-1754.744 1608.51-3546.036 1389.17-3728.825 1389.17"
                fill="#81b950"
            />
        </svg>
    );
};

export const ElasticsearchIcon = ({ width = '18px', height = '18px' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 256 256"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMinYMin meet"
        >
            <path
                d="M255.96 134.393c0-21.521-13.373-40.117-33.223-47.43a75.239 75.239 0 0 0 1.253-13.791c0-39.909-32.386-72.295-72.295-72.295-23.193 0-44.923 11.074-58.505 30.088-6.686-5.224-14.835-7.94-23.402-7.94-21.104 0-38.446 17.133-38.446 38.446 0 4.597.836 9.194 2.298 13.373C13.582 81.739 0 100.962 0 122.274c0 21.522 13.373 40.327 33.431 47.64-.835 4.388-1.253 8.985-1.253 13.79 0 39.7 32.386 72.087 72.086 72.087 23.402 0 44.924-11.283 58.505-30.088 6.686 5.223 15.044 8.149 23.611 8.149 21.104 0 38.446-17.134 38.446-38.446 0-4.597-.836-9.194-2.298-13.373 19.64-7.104 33.431-26.327 33.431-47.64z"
                fill="#FFF"
            />
            <path
                d="M100.085 110.364l57.043 26.119 57.669-50.565a64.312 64.312 0 0 0 1.253-12.746c0-35.52-28.834-64.355-64.355-64.355-21.313 0-41.162 10.447-53.072 27.998l-9.612 49.73 11.074 23.82z"
                fill="#F4BD19"
            />
            <path
                d="M40.953 170.75c-.835 4.179-1.253 8.567-1.253 12.955 0 35.52 29.043 64.564 64.564 64.564 21.522 0 41.372-10.656 53.49-28.208l9.403-49.729-12.746-24.238-57.251-26.118-56.207 50.774z"
                fill="#3CBEB1"
            />
            <path
                d="M40.536 71.918l39.073 9.194 8.775-44.506c-5.432-4.179-11.91-6.268-18.805-6.268-16.925 0-30.924 13.79-30.924 30.924 0 3.552.627 7.313 1.88 10.656z"
                fill="#E9478C"
            />
            <path
                d="M37.192 81.32c-17.551 5.642-29.67 22.567-29.67 40.954 0 17.97 11.074 34.059 27.79 40.327l54.953-49.73-10.03-21.52-43.043-10.03z"
                fill="#2C458F"
            />
            <path
                d="M167.784 219.852c5.432 4.18 11.91 6.478 18.596 6.478 16.925 0 30.924-13.79 30.924-30.924 0-3.761-.627-7.314-1.88-10.657l-39.073-9.193-8.567 44.296z"
                fill="#95C63D"
            />
            <path
                d="M175.724 165.317l43.043 10.03c17.551-5.85 29.67-22.566 29.67-40.954 0-17.97-11.074-33.849-27.79-40.326l-56.415 49.311 11.492 21.94z"
                fill="#176655"
            />
        </svg>
    );
};

export const WarningCircle = ({
    className = '',
    fill = '#ffc600',
    width = '20px',
    height = '20px',
}) => {
    return (
        <svg
            className={className}
            fill={fill}
            width={width}
            height={height}
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path>
            <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"></path>
        </svg>
    );
};


// jira ticket statuses svgs
export const JiraBugIcon = ({ width = '16', height = '16' }) => {
    return (
        <svg
            fill="none"
            height={height}
            viewBox="0 0 16 16"
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                clip-rule="evenodd"
                d="m8 2.5c-.82843 0-1.5.67157-1.5 1.5h3c0-.82843-.67157-1.5-1.5-1.5zm3 1.52074v-.02074c0-1.65685-1.34315-3-3-3s-3 1.34315-3 3v.02074c-.29048.04873-.55266.18096-.761.37115l-.88669-.63334-.91695-2.06315-1.37072.6092.94464 2.12544c.09062.20389.23416.37981.41572.50949l1.325.94643v1.11404h-3.25v1.5h3.25v1.14872l-1.14979.95818c-.13248.1104-.24068.247-.3178.4012l-1.20323 2.4065 1.34164.6708 1.17984-2.3597.46058-.3838c.63558 1.5764 2.17703 2.6581 3.94022 2.6581h.24854c1.71908 0 3.1849-1.0844 3.7506-2.6066l.3987.3323 1.1799 2.3597 1.3416-.6708-1.2032-2.4065c-.0771-.1542-.1853-.2908-.3178-.4012l-1.1498-.95818v-1.14872h3.25v-1.5h-3.25v-1.11404l1.325-.94643c.1816-.12968.3251-.3056.4157-.50949l.9447-2.12544-1.3708-.6092-.9169 2.06315-.8867.63334c-.2083-.19019-.4705-.32242-.761-.37115zm-.25 5.97926v-4.5h-5.5v4.44265l.03488.22675c.20629 1.3408 1.35998 2.3306 2.71658 2.3306h.24854c1.38071 0 2.5-1.1193 2.5-2.5z"
                fill="#f15b50"
                fill-rule="evenodd"
            />
        </svg>
    );
};
export const JiraTaskIcon = ({ width = '16', height = '16' }) => {
    return (
        <svg
            fill="none"
            height={height}
            viewBox="0 0 16 16"
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                clip-rule="evenodd"
                d="m1 3c0-1.10457.89543-2 2-2h10c1.1046 0 2 .89543 2 2v10c0 1.1046-.8954 2-2 2h-10c-1.10457 0-2-.8954-2-2zm2-.5c-.27614 0-.5.22386-.5.5v10c0 .2761.22386.5.5.5h10c.2761 0 .5-.2239.5-.5v-10c0-.27614-.2239-.5-.5-.5zm9.3262 2.98014-5.00003 5.99996c-.1425.171-.35359.2699-.57617.2699s-.43367-.0989-.57617-.2699l-2.5-2.99996 1.15234-.96028 1.92383 2.3086 4.4238-5.3086z"
                fill="#4688ec"
                fill-rule="evenodd"
            />
        </svg>
    );
};

export const JiraSubtaskIcon = ({ width = '16', height = '16' }) => {
    return (
        <svg
            fill="none"
            height={height}
            viewBox="0 0 16 16"
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                clip-rule="evenodd"
                d="m1 3c0-1.10457.89543-2 2-2h3.75c1.10457 0 2 .89543 2 2v4.25h4.25c1.1046 0 2 .89543 2 2v3.75c0 1.1046-.8954 2-2 2h-3.75c-1.10457 0-2-.8954-2-2v-4.25h-4.25c-1.10457 0-2-.89543-2-2zm6.25 4.25v-4.25c0-.27614-.22386-.5-.5-.5h-3.75c-.27614 0-.5.22386-.5.5v3.75c0 .27614.22386.5.5.5zm1.5 1.5v4.25c0 .2761.22386.5.5.5h3.75c.2761 0 .5-.2239.5-.5v-3.75c0-.27614-.2239-.5-.5-.5z"
                fill="#4688ec"
                fill-rule="evenodd"
            />
        </svg>
    );
};
export const JiraStoryIcon = ({ width = '16', height = '16' }) => {
    return (
        <svg
            fill="none"
            height={height}
            viewBox="0 0 16 16"
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                clip-rule="evenodd"
                d="m4.98291 2.5c-.27614 0-.5.22386-.5.5v9.8059l3.51724-2.4727 3.51775 2.4728v-9.806c0-.27614-.2239-.5-.5-.5zm-2 .5c0-1.10457.89543-2 2-2h6.03499c1.1046 0 2 .89543 2 2v11.25c0 .2799-.1559.5366-.4043.6656s-.548.109-.777-.052l-3.8364-2.6968-3.83595 2.6968c-.229.1609-.5286.181-.77702.052-.24843-.129-.40432-.3857-.40432-.6656z"
                fill="#6a9a23"
                fill-rule="evenodd"
            />
        </svg>
    );
};

export const JiraEpicIcon = ({ width = '16', height = '16' }) => {
    return (
        <svg
            fill="none"
            height={height}
            viewBox="0 0 16 16"
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                clip-rule="evenodd"
                d="m10.271.050656c.2887.111871.479.38969.479.699344v4.63515l3.1471.62941c.2652.05303.4812.24469.5655.50161s.0238.53933-.1584.73914l-7.74997 8.49999c-.20863.2288-.53644.3059-.82517.194-.28874-.1118-.47905-.3896-.47905-.6993v-4.6351l-3.14708-.62947c-.26515-.05303-.48123-.24468-.56553-.5016-.08431-.25692-.02379-.53933.1584-.73915l7.75-8.499996c.20863-.2288201.53643-.305899.8252-.194028zm-6.57276 8.724134 3.05177.61036v3.92915l5.55179-6.08909-3.05179-.61036v-3.9291z"
                fill="#bf63f3"
                fill-rule="evenodd"
            />
        </svg>
    );
};

